export const BasicChildSupportObligationOLDTableData = [
  {
    adjusted: "800",
    one_child: "197",
    two_children: "283",
    three_children: "330",
    four_children: "367",
    five_children: "404",
    six_children: "440",
  },
  {
    adjusted: "850",
    one_child: "208",
    two_children: "298",
    three_children: "347",
    four_children: "387",
    five_children: "425",
    six_children: "463",
  },
  {
    adjusted: "900",
    one_child: "218",
    two_children: "313",
    three_children: "364",
    four_children: "406",
    five_children: "447",
    six_children: "486",
  },
  {
    adjusted: "950",
    one_child: "229",
    two_children: "328",
    three_children: "381",
    four_children: "425",
    five_children: "468",
    six_children: "509",
  },
  {
    adjusted: "1000",
    one_child: "239",
    two_children: "343",
    three_children: "398",
    four_children: "444",
    five_children: "489",
    six_children: "532",
  },
  {
    adjusted: "1050",
    one_child: "250",
    two_children: "357",
    three_children: "415",
    four_children: "463",
    five_children: "510",
    six_children: "554",
  },
  {
    adjusted: "1100",
    one_child: "260",
    two_children: "372",
    three_children: "432",
    four_children: "482",
    five_children: "530",
    six_children: "577",
  },
  {
    adjusted: "1150",
    one_child: "270",
    two_children: "387",
    three_children: "449",
    four_children: "501",
    five_children: "551",
    six_children: "600",
  },
  {
    adjusted: "1200",
    one_child: "280",
    two_children: "401",
    three_children: "466",
    four_children: "520",
    five_children: "572",
    six_children: "622",
  },
  {
    adjusted: "1250",
    one_child: "291",
    two_children: "416",
    three_children: "483",
    four_children: "539",
    five_children: "593",
    six_children: "645",
  },
  {
    adjusted: "1300",
    one_child: "301",
    two_children: "431",
    three_children: "500",
    four_children: "558",
    five_children: "614",
    six_children: "668",
  },
  {
    adjusted: "1350",
    one_child: "311",
    two_children: "445",
    three_children: "517",
    four_children: "577",
    five_children: "634",
    six_children: "690",
  },
  {
    adjusted: "1400",
    one_child: "321",
    two_children: "459",
    three_children: "533",
    four_children: "594",
    five_children: "654",
    six_children: "711",
  },
  {
    adjusted: "1450",
    one_child: "331",
    two_children: "473",
    three_children: "549",
    four_children: "612",
    five_children: "673",
    six_children: "733",
  },
  {
    adjusted: "1500",
    one_child: "340",
    two_children: "487",
    three_children: "565",
    four_children: "630",
    five_children: "693",
    six_children: "754",
  },
  {
    adjusted: "1550",
    one_child: "350",
    two_children: "500",
    three_children: "581",
    four_children: "647",
    five_children: "712",
    six_children: "775",
  },
  {
    adjusted: "1600",
    one_child: "360",
    two_children: "514",
    three_children: "597",
    four_children: "665",
    five_children: "732",
    six_children: "796",
  },
  {
    adjusted: "1650",
    one_child: "369",
    two_children: "528",
    three_children: "612",
    four_children: "683",
    five_children: "751",
    six_children: "817",
  },
  {
    adjusted: "1700",
    one_child: "379",
    two_children: "542",
    three_children: "628",
    four_children: "701",
    five_children: "771",
    six_children: "838",
  },
  {
    adjusted: "1750",
    one_child: "389",
    two_children: "555",
    three_children: "644",
    four_children: "718",
    five_children: "790",
    six_children: "860",
  },
  {
    adjusted: "1800",
    one_child: "398",
    two_children: "569",
    three_children: "660",
    four_children: "736",
    five_children: "809",
    six_children: "881",
  },
  {
    adjusted: "1850",
    one_child: "408",
    two_children: "583",
    three_children: "676",
    four_children: "754",
    five_children: "829",
    six_children: "902",
  },
  {
    adjusted: "1900",
    one_child: "418",
    two_children: "596",
    three_children: "692",
    four_children: "771",
    five_children: "848",
    six_children: "923",
  },
  {
    adjusted: "1950",
    one_child: "427",
    two_children: "610",
    three_children: "708",
    four_children: "789",
    five_children: "868",
    six_children: "944",
  },
  {
    adjusted: "2000",
    one_child: "437",
    two_children: "624",
    three_children: "723",
    four_children: "807",
    five_children: "887",
    six_children: "965",
  },
  {
    adjusted: "2050",
    one_child: "446",
    two_children: "637",
    three_children: "739",
    four_children: "824",
    five_children: "906",
    six_children: "986",
  },
  {
    adjusted: "2100",
    one_child: "455",
    two_children: "650",
    three_children: "754",
    four_children: "840",
    five_children: "924",
    six_children: "1006",
  },
  {
    adjusted: "2150",
    one_child: "465",
    two_children: "663",
    three_children: "769",
    four_children: "857",
    five_children: "943",
    six_children: "1026",
  },
  {
    adjusted: "2200",
    one_child: "474",
    two_children: "676",
    three_children: "783",
    four_children: "873",
    five_children: "961",
    six_children: "1045",
  },
  {
    adjusted: "2250",
    one_child: "483",
    two_children: "688",
    three_children: "798",
    four_children: "890",
    five_children: "979",
    six_children: "1065",
  },
  {
    adjusted: "2300",
    one_child: "492",
    two_children: "701",
    three_children: "813",
    four_children: "907",
    five_children: "997",
    six_children: "1085",
  },
  {
    adjusted: "2350",
    one_child: "501",
    two_children: "714",
    three_children: "828",
    four_children: "923",
    five_children: "1016",
    six_children: "1105",
  },
  {
    adjusted: "2400",
    one_child: "510",
    two_children: "727",
    three_children: "843",
    four_children: "940",
    five_children: "1034",
    six_children: "1125",
  },
  {
    adjusted: "2450",
    one_child: "519",
    two_children: "740",
    three_children: "858",
    four_children: "956",
    five_children: "1052",
    six_children: "1145",
  },
  {
    adjusted: "2500",
    one_child: "528",
    two_children: "752",
    three_children: "873",
    four_children: "973",
    five_children: "1070",
    six_children: "1165",
  },
  {
    adjusted: "2550",
    one_child: "537",
    two_children: "765",
    three_children: "888",
    four_children: "990",
    five_children: "1089",
    six_children: "1184",
  },
  {
    adjusted: "2600",
    one_child: "547",
    two_children: "778",
    three_children: "902",
    four_children: "1006",
    five_children: "1107",
    six_children: "1204",
  },
  {
    adjusted: "2650",
    one_child: "556",
    two_children: "791",
    three_children: "917",
    four_children: "1023",
    five_children: "1125",
    six_children: "1224",
  },
  {
    adjusted: "2700",
    one_child: "565",
    two_children: "804",
    three_children: "932",
    four_children: "1039",
    five_children: "1143",
    six_children: "1244",
  },
  {
    adjusted: "2750",
    one_child: "574",
    two_children: "816",
    three_children: "947",
    four_children: "1056",
    five_children: "1162",
    six_children: "1264",
  },
  {
    adjusted: "2800",
    one_child: "583",
    two_children: "829",
    three_children: "962",
    four_children: "1073",
    five_children: "1180",
    six_children: "1284",
  },
  {
    adjusted: "2850",
    one_child: "592",
    two_children: "842",
    three_children: "977",
    four_children: "1089",
    five_children: "1198",
    six_children: "1303",
  },
  {
    adjusted: "2900",
    one_child: "601",
    two_children: "855",
    three_children: "992",
    four_children: "1106",
    five_children: "1216",
    six_children: "1323",
  },
  {
    adjusted: "2950",
    one_child: "611",
    two_children: "868",
    three_children: "1006",
    four_children: "1122",
    five_children: "1234",
    six_children: "1343",
  },
  {
    adjusted: "3000",
    one_child: "620",
    two_children: "881",
    three_children: "1021",
    four_children: "1139",
    five_children: "1253",
    six_children: "1363",
  },
  {
    adjusted: "3050",
    one_child: "629",
    two_children: "893",
    three_children: "1036",
    four_children: "1155",
    five_children: "1271",
    six_children: "1383",
  },
  {
    adjusted: "3100",
    one_child: "638",
    two_children: "906",
    three_children: "1051",
    four_children: "1172",
    five_children: "1289",
    six_children: "1402",
  },
  {
    adjusted: "3150",
    one_child: "647",
    two_children: "919",
    three_children: "1066",
    four_children: "1188",
    five_children: "1307",
    six_children: "1422",
  },
  {
    adjusted: "3200",
    one_child: "655",
    two_children: "930",
    three_children: "1079",
    four_children: "1203",
    five_children: "1323",
    six_children: "1440",
  },
  {
    adjusted: "3250",
    one_child: "663",
    two_children: "941",
    three_children: "1092",
    four_children: "1217",
    five_children: "1339",
    six_children: "1457",
  },
  {
    adjusted: "3300",
    one_child: "671",
    two_children: "952",
    three_children: "1104",
    four_children: "1231",
    five_children: "1355",
    six_children: "1474",
  },
  {
    adjusted: "3350",
    one_child: "679",
    two_children: "963",
    three_children: "1117",
    four_children: "1246",
    five_children: "1370",
    six_children: "1491",
  },
  {
    adjusted: "3400",
    one_child: "687",
    two_children: "974",
    three_children: "1130",
    four_children: "1260",
    five_children: "1386",
    six_children: "1508",
  },
  {
    adjusted: "3450",
    one_child: "694",
    two_children: "985",
    three_children: "1143",
    four_children: "1274",
    five_children: "1402",
    six_children: "1525",
  },
  {
    adjusted: "3500",
    one_child: "702",
    two_children: "996",
    three_children: "1155",
    four_children: "1288",
    five_children: "1417",
    six_children: "1542",
  },
  {
    adjusted: "3550",
    one_child: "710",
    two_children: "1008",
    three_children: "1168",
    four_children: "1303",
    five_children: "1433",
    six_children: "1559",
  },
  {
    adjusted: "3600",
    one_child: "718",
    two_children: "1019",
    three_children: "1181",
    four_children: "1317",
    five_children: "1448",
    six_children: "1576",
  },
  {
    adjusted: "3650",
    one_child: "726",
    two_children: "1030",
    three_children: "1194",
    four_children: "1331",
    five_children: "1464",
    six_children: "1593",
  },
  {
    adjusted: "3700",
    one_child: "734",
    two_children: "1041",
    three_children: "1207",
    four_children: "1345",
    five_children: "1480",
    six_children: "1610",
  },
  {
    adjusted: "3750",
    one_child: "741",
    two_children: "1051",
    three_children: "1219",
    four_children: "1359",
    five_children: "1495",
    six_children: "1627",
  },
  {
    adjusted: "3800",
    one_child: "749",
    two_children: "1062",
    three_children: "1231",
    four_children: "1373",
    five_children: "1510",
    six_children: "1643",
  },
  {
    adjusted: "3850",
    one_child: "756",
    two_children: "1072",
    three_children: "1243",
    four_children: "1386",
    five_children: "1525",
    six_children: "1659",
  },
  {
    adjusted: "3900",
    one_child: "764",
    two_children: "1083",
    three_children: "1255",
    four_children: "1400",
    five_children: "1540",
    six_children: "1675",
  },
  {
    adjusted: "3950",
    one_child: "771",
    two_children: "1093",
    three_children: "1267",
    four_children: "1413",
    five_children: "1555",
    six_children: "1691",
  },
  {
    adjusted: "4000",
    one_child: "779",
    two_children: "1104",
    three_children: "1280",
    four_children: "1427",
    five_children: "1569",
    six_children: "1707",
  },
  {
    adjusted: "4050",
    one_child: "786",
    two_children: "1114",
    three_children: "1292",
    four_children: "1440",
    five_children: "1584",
    six_children: "1724",
  },
  {
    adjusted: "4100",
    one_child: "794",
    two_children: "1125",
    three_children: "1304",
    four_children: "1454",
    five_children: "1599",
    six_children: "1740",
  },
  {
    adjusted: "4150",
    one_child: "801",
    two_children: "1135",
    three_children: "1316",
    four_children: "1467",
    five_children: "1614",
    six_children: "1756",
  },
  {
    adjusted: "4200",
    one_child: "809",
    two_children: "1146",
    three_children: "1328",
    four_children: "1481",
    five_children: "1629",
    six_children: "1772",
  },
  {
    adjusted: "4250",
    one_child: "816",
    two_children: "1156",
    three_children: "1340",
    four_children: "1494",
    five_children: "1643",
    six_children: "1788",
  },
  {
    adjusted: "4300",
    one_child: "824",
    two_children: "1167",
    three_children: "1352",
    four_children: "1508",
    five_children: "1658",
    six_children: "1804",
  },
  {
    adjusted: "4350",
    one_child: "831",
    two_children: "1177",
    three_children: "1364",
    four_children: "1521",
    five_children: "1673",
    six_children: "1820",
  },
  {
    adjusted: "4400",
    one_child: "839",
    two_children: "1188",
    three_children: "1376",
    four_children: "1534",
    five_children: "1688",
    six_children: "1836",
  },
  {
    adjusted: "4450",
    one_child: "846",
    two_children: "1198",
    three_children: "1388",
    four_children: "1548",
    five_children: "1703",
    six_children: "1853",
  },
  {
    adjusted: "4500",
    one_child: "853",
    two_children: "1209",
    three_children: "1400",
    four_children: "1561",
    five_children: "1718",
    six_children: "1869",
  },
  {
    adjusted: "4550",
    one_child: "861",
    two_children: "1219",
    three_children: "1412",
    four_children: "1575",
    five_children: "1732",
    six_children: "1885",
  },
  {
    adjusted: "4600",
    one_child: "868",
    two_children: "1230",
    three_children: "1425",
    four_children: "1588",
    five_children: "1747",
    six_children: "1901",
  },
  {
    adjusted: "4650",
    one_child: "876",
    two_children: "1240",
    three_children: "1437",
    four_children: "1602",
    five_children: "1762",
    six_children: "1917",
  },
  {
    adjusted: "4700",
    one_child: "883",
    two_children: "1251",
    three_children: "1449",
    four_children: "1615",
    five_children: "1777",
    six_children: "1933",
  },
  {
    adjusted: "4750",
    one_child: "891",
    two_children: "1261",
    three_children: "1461",
    four_children: "1629",
    five_children: "1792",
    six_children: "1949",
  },
  {
    adjusted: "4800",
    one_child: "898",
    two_children: "1271",
    three_children: "1473",
    four_children: "1642",
    five_children: "1807",
    six_children: "1966",
  },
  {
    adjusted: "4850",
    one_child: "906",
    two_children: "1282",
    three_children: "1485",
    four_children: "1656",
    five_children: "1821",
    six_children: "1982",
  },
  {
    adjusted: "4900",
    one_child: "911",
    two_children: "1289",
    three_children: "1493",
    four_children: "1664",
    five_children: "1831",
    six_children: "1992",
  },
  {
    adjusted: "4950",
    one_child: "914",
    two_children: "1293",
    three_children: "1496",
    four_children: "1668",
    five_children: "1835",
    six_children: "1997",
  },
  {
    adjusted: "5000",
    one_child: "917",
    two_children: "1297",
    three_children: "1500",
    four_children: "1672",
    five_children: "1839",
    six_children: "2001",
  },
  {
    adjusted: "5050",
    one_child: "921",
    two_children: "1300",
    three_children: "1503",
    four_children: "1676",
    five_children: "1844",
    six_children: "2006",
  },
  {
    adjusted: "5100",
    one_child: "924",
    two_children: "1304",
    three_children: "1507",
    four_children: "1680",
    five_children: "1848",
    six_children: "2011",
  },
  {
    adjusted: "5150",
    one_child: "927",
    two_children: "1308",
    three_children: "1510",
    four_children: "1684",
    five_children: "1852",
    six_children: "2015",
  },
  {
    adjusted: "5200",
    one_child: "930",
    two_children: "1312",
    three_children: "1514",
    four_children: "1688",
    five_children: "1857",
    six_children: "2020",
  },
  {
    adjusted: "5250",
    one_child: "934",
    two_children: "1316",
    three_children: "1517",
    four_children: "1692",
    five_children: "1861",
    six_children: "2025",
  },
  {
    adjusted: "5300",
    one_child: "937",
    two_children: "1320",
    three_children: "1521",
    four_children: "1696",
    five_children: "1865",
    six_children: "2029",
  },
  {
    adjusted: "5350",
    one_child: "940",
    two_children: "1323",
    three_children: "1524",
    four_children: "1700",
    five_children: "1870",
    six_children: "2034",
  },
  {
    adjusted: "5400",
    one_child: "943",
    two_children: "1327",
    three_children: "1528",
    four_children: "1704",
    five_children: "1874",
    six_children: "2039",
  },
  {
    adjusted: "5450",
    one_child: "947",
    two_children: "1331",
    three_children: "1531",
    four_children: "1708",
    five_children: "1878",
    six_children: "2044",
  },
  {
    adjusted: "5500",
    one_child: "950",
    two_children: "1335",
    three_children: "1535",
    four_children: "1711",
    five_children: "1883",
    six_children: "2048",
  },
  {
    adjusted: "5550",
    one_child: "953",
    two_children: "1339",
    three_children: "1538",
    four_children: "1715",
    five_children: "1887",
    six_children: "2053",
  },
  {
    adjusted: "5600",
    one_child: "956",
    two_children: "1342",
    three_children: "1542",
    four_children: "1719",
    five_children: "1891",
    six_children: "2058",
  },
  {
    adjusted: "5650",
    one_child: "960",
    two_children: "1347",
    three_children: "1546",
    four_children: "1724",
    five_children: "1896",
    six_children: "2063",
  },
  {
    adjusted: "5700",
    one_child: "964",
    two_children: "1352",
    three_children: "1552",
    four_children: "1731",
    five_children: "1904",
    six_children: "2071",
  },
  {
    adjusted: "5750",
    one_child: "968",
    two_children: "1357",
    three_children: "1558",
    four_children: "1737",
    five_children: "1911",
    six_children: "2079",
  },
  {
    adjusted: "5800",
    one_child: "971",
    two_children: "1363",
    three_children: "1564",
    four_children: "1744",
    five_children: "1918",
    six_children: "2087",
  },
  {
    adjusted: "5850",
    one_child: "975",
    two_children: "1368",
    three_children: "1570",
    four_children: "1750",
    five_children: "1925",
    six_children: "2094",
  },
  {
    adjusted: "5900",
    one_child: "979",
    two_children: "1373",
    three_children: "1575",
    four_children: "1757",
    five_children: "1932",
    six_children: "2102",
  },
  {
    adjusted: "5950",
    one_child: "983",
    two_children: "1379",
    three_children: "1581",
    four_children: "1763",
    five_children: "1939",
    six_children: "2110",
  },
  {
    adjusted: "6000",
    one_child: "987",
    two_children: "1384",
    three_children: "1587",
    four_children: "1770",
    five_children: "1947",
    six_children: "2118",
  },
  {
    adjusted: "6050",
    one_child: "991",
    two_children: "1389",
    three_children: "1593",
    four_children: "1776",
    five_children: "1954",
    six_children: "2126",
  },
  {
    adjusted: "6100",
    one_child: "995",
    two_children: "1394",
    three_children: "1599",
    four_children: "1783",
    five_children: "1961",
    six_children: "2133",
  },
  {
    adjusted: "6150",
    one_child: "999",
    two_children: "1400",
    three_children: "1605",
    four_children: "1789",
    five_children: "1968",
    six_children: "2141",
  },
  {
    adjusted: "6200",
    one_child: "1003",
    two_children: "1405",
    three_children: "1610",
    four_children: "1796",
    five_children: "1975",
    six_children: "2149",
  },
  {
    adjusted: "6250",
    one_child: "1007",
    two_children: "1410",
    three_children: "1616",
    four_children: "1802",
    five_children: "1982",
    six_children: "2157",
  },
  {
    adjusted: "6300",
    one_child: "1011",
    two_children: "1416",
    three_children: "1622",
    four_children: "1809",
    five_children: "1989",
    six_children: "2164",
  },
  {
    adjusted: "6350",
    one_child: "1015",
    two_children: "1421",
    three_children: "1628",
    four_children: "1815",
    five_children: "1996",
    six_children: "2172",
  },
  {
    adjusted: "6400",
    one_child: "1018",
    two_children: "1426",
    three_children: "1633",
    four_children: "1821",
    five_children: "2003",
    six_children: "2180",
  },
  {
    adjusted: "6450",
    one_child: "1023",
    two_children: "1432",
    three_children: "1639",
    four_children: "1828",
    five_children: "2011",
    six_children: "2188",
  },
  {
    adjusted: "6500",
    one_child: "1027",
    two_children: "1437",
    three_children: "1646",
    four_children: "1835",
    five_children: "2018",
    six_children: "2196",
  },
  {
    adjusted: "6550",
    one_child: "1031",
    two_children: "1442",
    three_children: "1652",
    four_children: "1841",
    five_children: "2026",
    six_children: "2204",
  },
  {
    adjusted: "6600",
    one_child: "1035",
    two_children: "1448",
    three_children: "1658",
    four_children: "1848",
    five_children: "2033",
    six_children: "2212",
  },
  {
    adjusted: "6650",
    one_child: "1039",
    two_children: "1453",
    three_children: "1664",
    four_children: "1855",
    five_children: "2040",
    six_children: "2220",
  },
  {
    adjusted: "6700",
    one_child: "1043",
    two_children: "1459",
    three_children: "1670",
    four_children: "1862",
    five_children: "2048",
    six_children: "2228",
  },
  {
    adjusted: "6750",
    one_child: "1047",
    two_children: "1464",
    three_children: "1676",
    four_children: "1869",
    five_children: "2055",
    six_children: "2236",
  },
  {
    adjusted: "6800",
    one_child: "1051",
    two_children: "1470",
    three_children: "1682",
    four_children: "1875",
    five_children: "2063",
    six_children: "2244",
  },
  {
    adjusted: "6850",
    one_child: "1055",
    two_children: "1475",
    three_children: "1688",
    four_children: "1882",
    five_children: "2070",
    six_children: "2252",
  },
  {
    adjusted: "6900",
    one_child: "1059",
    two_children: "1480",
    three_children: "1694",
    four_children: "1889",
    five_children: "2078",
    six_children: "2260",
  },
  {
    adjusted: "6950",
    one_child: "1063",
    two_children: "1486",
    three_children: "1700",
    four_children: "1896",
    five_children: "2085",
    six_children: "2269",
  },
  {
    adjusted: "7000",
    one_child: "1067",
    two_children: "1491",
    three_children: "1706",
    four_children: "1902",
    five_children: "2092",
    six_children: "2277",
  },
  {
    adjusted: "7050",
    one_child: "1071",
    two_children: "1497",
    three_children: "1712",
    four_children: "1909",
    five_children: "2100",
    six_children: "2285",
  },
  {
    adjusted: "7100",
    one_child: "1075",
    two_children: "1502",
    three_children: "1718",
    four_children: "1916",
    five_children: "2107",
    six_children: "2293",
  },
  {
    adjusted: "7150",
    one_child: "1079",
    two_children: "1508",
    three_children: "1724",
    four_children: "1923",
    five_children: "2115",
    six_children: "2301",
  },
  {
    adjusted: "7200",
    one_child: "1083",
    two_children: "1513",
    three_children: "1730",
    four_children: "1929",
    five_children: "2122",
    six_children: "2309",
  },
  {
    adjusted: "7250",
    one_child: "1087",
    two_children: "1518",
    three_children: "1736",
    four_children: "1936",
    five_children: "2130",
    six_children: "2317",
  },
  {
    adjusted: "7300",
    one_child: "1092",
    two_children: "1524",
    three_children: "1742",
    four_children: "1943",
    five_children: "2137",
    six_children: "2325",
  },
  {
    adjusted: "7350",
    one_child: "1096",
    two_children: "1529",
    three_children: "1748",
    four_children: "1950",
    five_children: "2144",
    six_children: "2333",
  },
  {
    adjusted: "7400",
    one_child: "1100",
    two_children: "1535",
    three_children: "1755",
    four_children: "1956",
    five_children: "2152",
    six_children: "2341",
  },
  {
    adjusted: "7450",
    one_child: "1104",
    two_children: "1540",
    three_children: "1761",
    four_children: "1963",
    five_children: "2159",
    six_children: "2349",
  },
  {
    adjusted: "7500",
    one_child: "1108",
    two_children: "1546",
    three_children: "1767",
    four_children: "1970",
    five_children: "2167",
    six_children: "2357",
  },
  {
    adjusted: "7550",
    one_child: "1112",
    two_children: "1552",
    three_children: "1773",
    four_children: "1977",
    five_children: "2175",
    six_children: "2366",
  },
  {
    adjusted: "7600",
    one_child: "1116",
    two_children: "1556",
    three_children: "1778",
    four_children: "1983",
    five_children: "2181",
    six_children: "2373",
  },
  {
    adjusted: "7650",
    one_child: "1117",
    two_children: "1557",
    three_children: "1779",
    four_children: "1984",
    five_children: "2182",
    six_children: "2375",
  },
  {
    adjusted: "7700",
    one_child: "1118",
    two_children: "1559",
    three_children: "1781",
    four_children: "1986",
    five_children: "2184",
    six_children: "2376",
  },
  {
    adjusted: "7750",
    one_child: "1119",
    two_children: "1560",
    three_children: "1782",
    four_children: "1987",
    five_children: "2186",
    six_children: "2378",
  },
  {
    adjusted: "7800",
    one_child: "1120",
    two_children: "1562",
    three_children: "1784",
    four_children: "1989",
    five_children: "2188",
    six_children: "2380",
  },
  {
    adjusted: "7850",
    one_child: "1122",
    two_children: "1563",
    three_children: "1785",
    four_children: "1990",
    five_children: "2189",
    six_children: "2382",
  },
  {
    adjusted: "7900",
    one_child: "1123",
    two_children: "1565",
    three_children: "1786",
    four_children: "1992",
    five_children: "2191",
    six_children: "2384",
  },
  {
    adjusted: "7950",
    one_child: "1124",
    two_children: "1566",
    three_children: "1788",
    four_children: "1993",
    five_children: "2193",
    six_children: "2386",
  },
  {
    adjusted: "8000",
    one_child: "1125",
    two_children: "1567",
    three_children: "1789",
    four_children: "1995",
    five_children: "2194",
    six_children: "2387",
  },
  {
    adjusted: "8050",
    one_child: "1127",
    two_children: "1569",
    three_children: "1790",
    four_children: "1996",
    five_children: "2196",
    six_children: "2389",
  },
  {
    adjusted: "8100",
    one_child: "1128",
    two_children: "1570",
    three_children: "1792",
    four_children: "1998",
    five_children: "2198",
    six_children: "2391",
  },
  {
    adjusted: "8150",
    one_child: "1129",
    two_children: "1572",
    three_children: "1793",
    four_children: "1999",
    five_children: "2199",
    six_children: "2393",
  },
  {
    adjusted: "8200",
    one_child: "1130",
    two_children: "1573",
    three_children: "1795",
    four_children: "2001",
    five_children: "2201",
    six_children: "2395",
  },
  {
    adjusted: "8250",
    one_child: "1131",
    two_children: "1575",
    three_children: "1796",
    four_children: "2003",
    five_children: "2203",
    six_children: "2397",
  },
  {
    adjusted: "8300",
    one_child: "1133",
    two_children: "1576",
    three_children: "1797",
    four_children: "2004",
    five_children: "2204",
    six_children: "2398",
  },
  {
    adjusted: "8350",
    one_child: "1134",
    two_children: "1578",
    three_children: "1799",
    four_children: "2006",
    five_children: "2206",
    six_children: "2400",
  },
  {
    adjusted: "8400",
    one_child: "1135",
    two_children: "1579",
    three_children: "1800",
    four_children: "2007",
    five_children: "2208",
    six_children: "2402",
  },
  {
    adjusted: "8450",
    one_child: "1136",
    two_children: "1580",
    three_children: "1802",
    four_children: "2009",
    five_children: "2210",
    six_children: "2404",
  },
  {
    adjusted: "8500",
    one_child: "1138",
    two_children: "1582",
    three_children: "1803",
    four_children: "2010",
    five_children: "2211",
    six_children: "2406",
  },
  {
    adjusted: "8550",
    one_child: "1139",
    two_children: "1583",
    three_children: "1804",
    four_children: "2012",
    five_children: "2213",
    six_children: "2408",
  },
  {
    adjusted: "8600",
    one_child: "1140",
    two_children: "1585",
    three_children: "1806",
    four_children: "2013",
    five_children: "2215",
    six_children: "2410",
  },
  {
    adjusted: "8650",
    one_child: "1141",
    two_children: "1586",
    three_children: "1807",
    four_children: "2015",
    five_children: "2216",
    six_children: "2411",
  },
  {
    adjusted: "8700",
    one_child: "1142",
    two_children: "1588",
    three_children: "1808",
    four_children: "2016",
    five_children: "2218",
    six_children: "2413",
  },
  {
    adjusted: "8750",
    one_child: "1144",
    two_children: "1589",
    three_children: "1810",
    four_children: "2018",
    five_children: "2220",
    six_children: "2415",
  },
  {
    adjusted: "8800",
    one_child: "1145",
    two_children: "1591",
    three_children: "1811",
    four_children: "2019",
    five_children: "2221",
    six_children: "2417",
  },
  {
    adjusted: "8850",
    one_child: "1146",
    two_children: "1592",
    three_children: "1813",
    four_children: "2021",
    five_children: "2223",
    six_children: "2419",
  },
  {
    adjusted: "8900",
    one_child: "1147",
    two_children: "1593",
    three_children: "1814",
    four_children: "2023",
    five_children: "2225",
    six_children: "2421",
  },
  {
    adjusted: "8950",
    one_child: "1149",
    two_children: "1595",
    three_children: "1815",
    four_children: "2024",
    five_children: "2226",
    six_children: "2422",
  },
  {
    adjusted: "9000",
    one_child: "1150",
    two_children: "1596",
    three_children: "1817",
    four_children: "2026",
    five_children: "2228",
    six_children: "2424",
  },
  {
    adjusted: "9050",
    one_child: "1153",
    two_children: "1601",
    three_children: "1822",
    four_children: "2032",
    five_children: "2235",
    six_children: "2431",
  },
  {
    adjusted: "9100",
    one_child: "1159",
    two_children: "1609",
    three_children: "1831",
    four_children: "2042",
    five_children: "2246",
    six_children: "2443",
  },
  {
    adjusted: "9150",
    one_child: "1164",
    two_children: "1617",
    three_children: "1840",
    four_children: "2052",
    five_children: "2257",
    six_children: "2455",
  },
  {
    adjusted: "9200",
    one_child: "1170",
    two_children: "1624",
    three_children: "1849",
    four_children: "2062",
    five_children: "2268",
    six_children: "2467",
  },
  {
    adjusted: "9250",
    one_child: "1175",
    two_children: "1632",
    three_children: "1858",
    four_children: "2071",
    five_children: "2279",
    six_children: "2479",
  },
  {
    adjusted: "9300",
    one_child: "1181",
    two_children: "1640",
    three_children: "1867",
    four_children: "2081",
    five_children: "2290",
    six_children: "2491",
  },
  {
    adjusted: "9350",
    one_child: "1187",
    two_children: "1648",
    three_children: "1876",
    four_children: "2091",
    five_children: "2301",
    six_children: "2503",
  },
  {
    adjusted: "9400",
    one_child: "1192",
    two_children: "1656",
    three_children: "1885",
    four_children: "2101",
    five_children: "2311",
    six_children: "2515",
  },
  {
    adjusted: "9450",
    one_child: "1198",
    two_children: "1663",
    three_children: "1894",
    four_children: "2111",
    five_children: "2322",
    six_children: "2527",
  },
  {
    adjusted: "9500",
    one_child: "1203",
    two_children: "1671",
    three_children: "1902",
    four_children: "2121",
    five_children: "2333",
    six_children: "2539",
  },
  {
    adjusted: "9550",
    one_child: "1209",
    two_children: "1679",
    three_children: "1911",
    four_children: "2131",
    five_children: "2344",
    six_children: "2551",
  },
  {
    adjusted: "9600",
    one_child: "1214",
    two_children: "1687",
    three_children: "1920",
    four_children: "2141",
    five_children: "2355",
    six_children: "2563",
  },
  {
    adjusted: "9650",
    one_child: "1220",
    two_children: "1694",
    three_children: "1929",
    four_children: "2151",
    five_children: "2366",
    six_children: "2574",
  },
  {
    adjusted: "9700",
    one_child: "1226",
    two_children: "1702",
    three_children: "1938",
    four_children: "2161",
    five_children: "2377",
    six_children: "2586",
  },
  {
    adjusted: "9750",
    one_child: "1231",
    two_children: "1710",
    three_children: "1947",
    four_children: "2171",
    five_children: "2388",
    six_children: "2598",
  },
  {
    adjusted: "9800",
    one_child: "1237",
    two_children: "1718",
    three_children: "1956",
    four_children: "2181",
    five_children: "2399",
    six_children: "2610",
  },
  {
    adjusted: "9850",
    one_child: "1242",
    two_children: "1725",
    three_children: "1965",
    four_children: "2191",
    five_children: "2410",
    six_children: "2622",
  },
  {
    adjusted: "9900",
    one_child: "1248",
    two_children: "1733",
    three_children: "1974",
    four_children: "2201",
    five_children: "2421",
    six_children: "2634",
  },
  {
    adjusted: "9950",
    one_child: "1253",
    two_children: "1741",
    three_children: "1983",
    four_children: "2211",
    five_children: "2432",
    six_children: "2646",
  },
  {
    adjusted: "10000",
    one_child: "1259",
    two_children: "1749",
    three_children: "1992",
    four_children: "2221",
    five_children: "2443",
    six_children: "2658",
  },
  {
    adjusted: "10050",
    one_child: "1264",
    two_children: "1757",
    three_children: "2001",
    four_children: "2231",
    five_children: "2454",
    six_children: "2670",
  },
  {
    adjusted: "10100",
    one_child: "1270",
    two_children: "1764",
    three_children: "2010",
    four_children: "2241",
    five_children: "2465",
    six_children: "2682",
  },
  {
    adjusted: "10150",
    one_child: "1276",
    two_children: "1772",
    three_children: "2019",
    four_children: "2251",
    five_children: "2476",
    six_children: "2694",
  },
  {
    adjusted: "10200",
    one_child: "1281",
    two_children: "1780",
    three_children: "2028",
    four_children: "2261",
    five_children: "2487",
    six_children: "2706",
  },
  {
    adjusted: "10250",
    one_child: "1287",
    two_children: "1788",
    three_children: "2036",
    four_children: "2271",
    five_children: "2498",
    six_children: "2718",
  },
  {
    adjusted: "10300",
    one_child: "1292",
    two_children: "1795",
    three_children: "2045",
    four_children: "2281",
    five_children: "2509",
    six_children: "2729",
  },
  {
    adjusted: "10350",
    one_child: "1298",
    two_children: "1803",
    three_children: "2054",
    four_children: "2291",
    five_children: "2520",
    six_children: "2741",
  },
  {
    adjusted: "10400",
    one_child: "1303",
    two_children: "1811",
    three_children: "2063",
    four_children: "2301",
    five_children: "2531",
    six_children: "2753",
  },
  {
    adjusted: "10450",
    one_child: "1309",
    two_children: "1819",
    three_children: "2072",
    four_children: "2311",
    five_children: "2542",
    six_children: "2765",
  },
  {
    adjusted: "10500",
    one_child: "1313",
    two_children: "1825",
    three_children: "2079",
    four_children: "2318",
    five_children: "2550",
    six_children: "2774",
  },
  {
    adjusted: "10550",
    one_child: "1317",
    two_children: "1830",
    three_children: "2085",
    four_children: "2325",
    five_children: "2557",
    six_children: "2782",
  },
  {
    adjusted: "10600",
    one_child: "1321",
    two_children: "1835",
    three_children: "2091",
    four_children: "2331",
    five_children: "2564",
    six_children: "2790",
  },
  {
    adjusted: "10650",
    one_child: "1325",
    two_children: "1841",
    three_children: "2096",
    four_children: "2338",
    five_children: "2571",
    six_children: "2798",
  },
  {
    adjusted: "10700",
    one_child: "1329",
    two_children: "1846",
    three_children: "2102",
    four_children: "2344",
    five_children: "2578",
    six_children: "2805",
  },
  {
    adjusted: "10750",
    one_child: "1332",
    two_children: "1851",
    three_children: "2108",
    four_children: "2351",
    five_children: "2586",
    six_children: "2813",
  },
  {
    adjusted: "10800",
    one_child: "1336",
    two_children: "1856",
    three_children: "2114",
    four_children: "2357",
    five_children: "2593",
    six_children: "2821",
  },
  {
    adjusted: "10850",
    one_child: "1340",
    two_children: "1862",
    three_children: "2120",
    four_children: "2364",
    five_children: "2600",
    six_children: "2829",
  },
  {
    adjusted: "10900",
    one_child: "1344",
    two_children: "1867",
    three_children: "2126",
    four_children: "2370",
    five_children: "2607",
    six_children: "2836",
  },
  {
    adjusted: "10950",
    one_child: "1348",
    two_children: "1872",
    three_children: "2131",
    four_children: "2377",
    five_children: "2614",
    six_children: "2844",
  },
  {
    adjusted: "11000",
    one_child: "1351",
    two_children: "1877",
    three_children: "2137",
    four_children: "2383",
    five_children: "2621",
    six_children: "2852",
  },
  {
    adjusted: "11050",
    one_child: "1355",
    two_children: "1883",
    three_children: "2143",
    four_children: "2390",
    five_children: "2628",
    six_children: "2860",
  },
  {
    adjusted: "11100",
    one_child: "1359",
    two_children: "1888",
    three_children: "2149",
    four_children: "2396",
    five_children: "2636",
    six_children: "2868",
  },
  {
    adjusted: "11150",
    one_child: "1363",
    two_children: "1893",
    three_children: "2155",
    four_children: "2403",
    five_children: "2643",
    six_children: "2875",
  },
  {
    adjusted: "11200",
    one_child: "1367",
    two_children: "1898",
    three_children: "2161",
    four_children: "2409",
    five_children: "2650",
    six_children: "2883",
  },
  {
    adjusted: "11250",
    one_child: "1371",
    two_children: "1904",
    three_children: "2166",
    four_children: "2415",
    five_children: "2657",
    six_children: "2891",
  },
  {
    adjusted: "11300",
    one_child: "1374",
    two_children: "1909",
    three_children: "2172",
    four_children: "2422",
    five_children: "2664",
    six_children: "2899",
  },
  {
    adjusted: "11350",
    one_child: "1378",
    two_children: "1914",
    three_children: "2178",
    four_children: "2428",
    five_children: "2671",
    six_children: "2906",
  },
  {
    adjusted: "11400",
    one_child: "1382",
    two_children: "1919",
    three_children: "2184",
    four_children: "2435",
    five_children: "2678",
    six_children: "2914",
  },
  {
    adjusted: "11450",
    one_child: "1386",
    two_children: "1925",
    three_children: "2190",
    four_children: "2441",
    five_children: "2686",
    six_children: "2922",
  },
  {
    adjusted: "11500",
    one_child: "1390",
    two_children: "1930",
    three_children: "2195",
    four_children: "2448",
    five_children: "2693",
    six_children: "2930",
  },
  {
    adjusted: "11550",
    one_child: "1394",
    two_children: "1935",
    three_children: "2201",
    four_children: "2454",
    five_children: "2700",
    six_children: "2938",
  },
  {
    adjusted: "11600",
    one_child: "1397",
    two_children: "1940",
    three_children: "2207",
    four_children: "2461",
    five_children: "2707",
    six_children: "2945",
  },
  {
    adjusted: "11650",
    one_child: "1401",
    two_children: "1946",
    three_children: "2213",
    four_children: "2467",
    five_children: "2714",
    six_children: "2953",
  },
  {
    adjusted: "11700",
    one_child: "1405",
    two_children: "1951",
    three_children: "2219",
    four_children: "2474",
    five_children: "2721",
    six_children: "2961",
  },
  {
    adjusted: "11750",
    one_child: "1409",
    two_children: "1956",
    three_children: "2225",
    four_children: "2480",
    five_children: "2728",
    six_children: "2969",
  },
  {
    adjusted: "11800",
    one_child: "1413",
    two_children: "1961",
    three_children: "2230",
    four_children: "2487",
    five_children: "2736",
    six_children: "2976",
  },
  {
    adjusted: "11850",
    one_child: "1417",
    two_children: "1967",
    three_children: "2236",
    four_children: "2493",
    five_children: "2743",
    six_children: "2984",
  },
  {
    adjusted: "11900",
    one_child: "1420",
    two_children: "1972",
    three_children: "2242",
    four_children: "2500",
    five_children: "2750",
    six_children: "2992",
  },
  {
    adjusted: "11950",
    one_child: "1424",
    two_children: "1977",
    three_children: "2248",
    four_children: "2506",
    five_children: "2757",
    six_children: "3000",
  },
  {
    adjusted: "12000",
    one_child: "1428",
    two_children: "1982",
    three_children: "2254",
    four_children: "2513",
    five_children: "2764",
    six_children: "3007",
  },
  {
    adjusted: "12050",
    one_child: "1432",
    two_children: "1988",
    three_children: "2260",
    four_children: "2519",
    five_children: "2771",
    six_children: "3015",
  },
  {
    adjusted: "12100",
    one_child: "1436",
    two_children: "1993",
    three_children: "2265",
    four_children: "2526",
    five_children: "2779",
    six_children: "3023",
  },
  {
    adjusted: "12150",
    one_child: "1439",
    two_children: "1998",
    three_children: "2271",
    four_children: "2532",
    five_children: "2786",
    six_children: "3031",
  },
  {
    adjusted: "12200",
    one_child: "1443",
    two_children: "2003",
    three_children: "2277",
    four_children: "2539",
    five_children: "2793",
    six_children: "3039",
  },
  {
    adjusted: "12250",
    one_child: "1447",
    two_children: "2009",
    three_children: "2283",
    four_children: "2545",
    five_children: "2800",
    six_children: "3046",
  },
  {
    adjusted: "12300",
    one_child: "1451",
    two_children: "2014",
    three_children: "2289",
    four_children: "2552",
    five_children: "2807",
    six_children: "3054",
  },
  {
    adjusted: "12350",
    one_child: "1455",
    two_children: "2019",
    three_children: "2295",
    four_children: "2558",
    five_children: "2814",
    six_children: "3062",
  },
  {
    adjusted: "12400",
    one_child: "1459",
    two_children: "2024",
    three_children: "2300",
    four_children: "2565",
    five_children: "2821",
    six_children: "3070",
  },
  {
    adjusted: "12450",
    one_child: "1462",
    two_children: "2030",
    three_children: "2306",
    four_children: "2571",
    five_children: "2829",
    six_children: "3077",
  },
  {
    adjusted: "12500",
    one_child: "1466",
    two_children: "2035",
    three_children: "2312",
    four_children: "2578",
    five_children: "2836",
    six_children: "3085",
  },
  {
    adjusted: "12550",
    one_child: "1470",
    two_children: "2040",
    three_children: "2318",
    four_children: "2584",
    five_children: "2843",
    six_children: "3093",
  },
  {
    adjusted: "12600",
    one_child: "1474",
    two_children: "2045",
    three_children: "2324",
    four_children: "2591",
    five_children: "2850",
    six_children: "3101",
  },
  {
    adjusted: "12650",
    one_child: "1477",
    two_children: "2050",
    three_children: "2329",
    four_children: "2597",
    five_children: "2857",
    six_children: "3108",
  },
  {
    adjusted: "12700",
    one_child: "1481",
    two_children: "2055",
    three_children: "2335",
    four_children: "2603",
    five_children: "2863",
    six_children: "3115",
  },
  {
    adjusted: "12750",
    one_child: "1484",
    two_children: "2060",
    three_children: "2340",
    four_children: "2609",
    five_children: "2870",
    six_children: "3123",
  },
  {
    adjusted: "12800",
    one_child: "1487",
    two_children: "2064",
    three_children: "2345",
    four_children: "2615",
    five_children: "2877",
    six_children: "3130",
  },
  {
    adjusted: "12850",
    one_child: "1491",
    two_children: "2069",
    three_children: "2351",
    four_children: "2621",
    five_children: "2883",
    six_children: "3137",
  },
  {
    adjusted: "12900",
    one_child: "1494",
    two_children: "2074",
    three_children: "2356",
    four_children: "2627",
    five_children: "2890",
    six_children: "3144",
  },
  {
    adjusted: "12950",
    one_child: "1497",
    two_children: "2078",
    three_children: "2361",
    four_children: "2633",
    five_children: "2896",
    six_children: "3151",
  },
  {
    adjusted: "13000",
    one_child: "1501",
    two_children: "2083",
    three_children: "2367",
    four_children: "2639",
    five_children: "2903",
    six_children: "3158",
  },
  {
    adjusted: "13050",
    one_child: "1504",
    two_children: "2087",
    three_children: "2372",
    four_children: "2645",
    five_children: "2909",
    six_children: "3165",
  },
  {
    adjusted: "13100",
    one_child: "1507",
    two_children: "2092",
    three_children: "2377",
    four_children: "2651",
    five_children: "2916",
    six_children: "3172",
  },
  {
    adjusted: "13150",
    one_child: "1510",
    two_children: "2097",
    three_children: "2383",
    four_children: "2657",
    five_children: "2922",
    six_children: "3180",
  },
  {
    adjusted: "13200",
    one_child: "1514",
    two_children: "2101",
    three_children: "2388",
    four_children: "2663",
    five_children: "2929",
    six_children: "3187",
  },
  {
    adjusted: "13250",
    one_child: "1517",
    two_children: "2106",
    three_children: "2393",
    four_children: "2668",
    five_children: "2935",
    six_children: "3193",
  },
  {
    adjusted: "13300",
    one_child: "1520",
    two_children: "2110",
    three_children: "2398",
    four_children: "2674",
    five_children: "2941",
    six_children: "3200",
  },
  {
    adjusted: "13350",
    one_child: "1523",
    two_children: "2114",
    three_children: "2403",
    four_children: "2679",
    five_children: "2947",
    six_children: "3206",
  },
  {
    adjusted: "13400",
    one_child: "1526",
    two_children: "2118",
    three_children: "2408",
    four_children: "2685",
    five_children: "2953",
    six_children: "3213",
  },
  {
    adjusted: "13450",
    one_child: "1529",
    two_children: "2123",
    three_children: "2413",
    four_children: "2690",
    five_children: "2959",
    six_children: "3220",
  },
  {
    adjusted: "13500",
    one_child: "1532",
    two_children: "2127",
    three_children: "2418",
    four_children: "2696",
    five_children: "2965",
    six_children: "3226",
  },
  {
    adjusted: "13550",
    one_child: "1535",
    two_children: "2131",
    three_children: "2423",
    four_children: "2701",
    five_children: "2971",
    six_children: "3233",
  },
  {
    adjusted: "13600",
    one_child: "1538",
    two_children: "2136",
    three_children: "2428",
    four_children: "2707",
    five_children: "2977",
    six_children: "3239",
  },
  {
    adjusted: "13650",
    one_child: "1541",
    two_children: "2140",
    three_children: "2432",
    four_children: "2712",
    five_children: "2983",
    six_children: "3246",
  },
  {
    adjusted: "13700",
    one_child: "1544",
    two_children: "2144",
    three_children: "2437",
    four_children: "2718",
    five_children: "2989",
    six_children: "3253",
  },
  {
    adjusted: "13750",
    one_child: "1547",
    two_children: "2148",
    three_children: "2442",
    four_children: "2723",
    five_children: "2996",
    six_children: "3259",
  },
  {
    adjusted: "13800",
    one_child: "1550",
    two_children: "2153",
    three_children: "2447",
    four_children: "2729",
    five_children: "3002",
    six_children: "3266",
  },
  {
    adjusted: "13850",
    one_child: "1553",
    two_children: "2157",
    three_children: "2452",
    four_children: "2734",
    five_children: "3008",
    six_children: "3272",
  },
  {
    adjusted: "13900",
    one_child: "1556",
    two_children: "2161",
    three_children: "2457",
    four_children: "2740",
    five_children: "3014",
    six_children: "3279",
  },
  {
    adjusted: "13950",
    one_child: "1559",
    two_children: "2166",
    three_children: "2462",
    four_children: "2745",
    five_children: "3020",
    six_children: "3285",
  },
  {
    adjusted: "14000",
    one_child: "1562",
    two_children: "2170",
    three_children: "2467",
    four_children: "2751",
    five_children: "3026",
    six_children: "3292",
  },
  {
    adjusted: "14050",
    one_child: "1565",
    two_children: "2174",
    three_children: "2472",
    four_children: "2756",
    five_children: "3032",
    six_children: "3299",
  },
  {
    adjusted: "14100",
    one_child: "1568",
    two_children: "2178",
    three_children: "2477",
    four_children: "2762",
    five_children: "3038",
    six_children: "3305",
  },
  {
    adjusted: "14150",
    one_child: "1571",
    two_children: "2183",
    three_children: "2482",
    four_children: "2767",
    five_children: "3044",
    six_children: "3312",
  },
  {
    adjusted: "14200",
    one_child: "1574",
    two_children: "2187",
    three_children: "2487",
    four_children: "2773",
    five_children: "3050",
    six_children: "3318",
  },
  {
    adjusted: "14250",
    one_child: "1577",
    two_children: "2191",
    three_children: "2492",
    four_children: "2778",
    five_children: "3056",
    six_children: "3325",
  },
  {
    adjusted: "14300",
    one_child: "1581",
    two_children: "2195",
    three_children: "2497",
    four_children: "2784",
    five_children: "3062",
    six_children: "3332",
  },
  {
    adjusted: "14350",
    one_child: "1584",
    two_children: "2200",
    three_children: "2502",
    four_children: "2789",
    five_children: "3068",
    six_children: "3338",
  },
  {
    adjusted: "14400",
    one_child: "1587",
    two_children: "2204",
    three_children: "2506",
    four_children: "2795",
    five_children: "3074",
    six_children: "3345",
  },
  {
    adjusted: "14450",
    one_child: "1590",
    two_children: "2208",
    three_children: "2511",
    four_children: "2800",
    five_children: "3080",
    six_children: "3351",
  },
  {
    adjusted: "14500",
    one_child: "1593",
    two_children: "2213",
    three_children: "2516",
    four_children: "2806",
    five_children: "3086",
    six_children: "3358",
  },
  {
    adjusted: "14550",
    one_child: "1596",
    two_children: "2217",
    three_children: "2521",
    four_children: "2811",
    five_children: "3092",
    six_children: "3365",
  },
  {
    adjusted: "14600",
    one_child: "1599",
    two_children: "2221",
    three_children: "2526",
    four_children: "2817",
    five_children: "3098",
    six_children: "3371",
  },
  {
    adjusted: "14650",
    one_child: "1602",
    two_children: "2225",
    three_children: "2531",
    four_children: "2822",
    five_children: "3104",
    six_children: "3378",
  },
  {
    adjusted: "14700",
    one_child: "1605",
    two_children: "2230",
    three_children: "2536",
    four_children: "2828",
    five_children: "3111",
    six_children: "3384",
  },
  {
    adjusted: "14750",
    one_child: "1608",
    two_children: "2234",
    three_children: "2541",
    four_children: "2833",
    five_children: "3117",
    six_children: "3391",
  },
  {
    adjusted: "14800",
    one_child: "1611",
    two_children: "2238",
    three_children: "2546",
    four_children: "2839",
    five_children: "3123",
    six_children: "3397",
  },
  {
    adjusted: "14850",
    one_child: "1614",
    two_children: "2243",
    three_children: "2551",
    four_children: "2844",
    five_children: "3129",
    six_children: "3404",
  },
  {
    adjusted: "14900",
    one_child: "1617",
    two_children: "2247",
    three_children: "2556",
    four_children: "2850",
    five_children: "3135",
    six_children: "3411",
  },
  {
    adjusted: "14950",
    one_child: "1620",
    two_children: "2251",
    three_children: "2561",
    four_children: "2855",
    five_children: "3141",
    six_children: "3417",
  },
  {
    adjusted: "15000",
    one_child: "1623",
    two_children: "2255",
    three_children: "2566",
    four_children: "2861",
    five_children: "3147",
    six_children: "3424",
  },
  {
    adjusted: "15050",
    one_child: "1626",
    two_children: "2260",
    three_children: "2571",
    four_children: "2866",
    five_children: "3153",
    six_children: "3430",
  },
  {
    adjusted: "15100",
    one_child: "1629",
    two_children: "2264",
    three_children: "2576",
    four_children: "2872",
    five_children: "3159",
    six_children: "3437",
  },
  {
    adjusted: "15150",
    one_child: "1632",
    two_children: "2268",
    three_children: "2581",
    four_children: "2877",
    five_children: "3165",
    six_children: "3444",
  },
  {
    adjusted: "15200",
    one_child: "1635",
    two_children: "2272",
    three_children: "2585",
    four_children: "2883",
    five_children: "3171",
    six_children: "3450",
  },
  {
    adjusted: "15250",
    one_child: "1638",
    two_children: "2277",
    three_children: "2590",
    four_children: "2888",
    five_children: "3177",
    six_children: "3457",
  },
  {
    adjusted: "15300",
    one_child: "1641",
    two_children: "2281",
    three_children: "2595",
    four_children: "2894",
    five_children: "3183",
    six_children: "3463",
  },
  {
    adjusted: "15350",
    one_child: "1644",
    two_children: "2285",
    three_children: "2600",
    four_children: "2899",
    five_children: "3189",
    six_children: "3470",
  },
  {
    adjusted: "15400",
    one_child: "1647",
    two_children: "2290",
    three_children: "2605",
    four_children: "2905",
    five_children: "3195",
    six_children: "3476",
  },
  {
    adjusted: "15450",
    one_child: "1650",
    two_children: "2294",
    three_children: "2610",
    four_children: "2910",
    five_children: "3201",
    six_children: "3483",
  },
  {
    adjusted: "15500",
    one_child: "1653",
    two_children: "2298",
    three_children: "2615",
    four_children: "2916",
    five_children: "3207",
    six_children: "3490",
  },
  {
    adjusted: "15550",
    one_child: "1656",
    two_children: "2302",
    three_children: "2620",
    four_children: "2921",
    five_children: "3213",
    six_children: "3496",
  },
  {
    adjusted: "15600",
    one_child: "1659",
    two_children: "2307",
    three_children: "2625",
    four_children: "2927",
    five_children: "3219",
    six_children: "3503",
  },
  {
    adjusted: "15650",
    one_child: "1663",
    two_children: "2311",
    three_children: "2630",
    four_children: "2932",
    five_children: "3226",
    six_children: "3509",
  },
  {
    adjusted: "15700",
    one_child: "1666",
    two_children: "2315",
    three_children: "2635",
    four_children: "2938",
    five_children: "3232",
    six_children: "3516",
  },
  {
    adjusted: "15750",
    one_child: "1669",
    two_children: "2320",
    three_children: "2640",
    four_children: "2943",
    five_children: "3238",
    six_children: "3523",
  },
  {
    adjusted: "15800",
    one_child: "1672",
    two_children: "2324",
    three_children: "2645",
    four_children: "2949",
    five_children: "3244",
    six_children: "3529",
  },
  {
    adjusted: "15850",
    one_child: "1675",
    two_children: "2328",
    three_children: "2650",
    four_children: "2954",
    five_children: "3250",
    six_children: "3536",
  },
  {
    adjusted: "15900",
    one_child: "1678",
    two_children: "2332",
    three_children: "2655",
    four_children: "2960",
    five_children: "3256",
    six_children: "3542",
  },
  {
    adjusted: "15950",
    one_child: "1681",
    two_children: "2337",
    three_children: "2659",
    four_children: "2965",
    five_children: "3262",
    six_children: "3549",
  },
  {
    adjusted: "16000",
    one_child: "1684",
    two_children: "2341",
    three_children: "2664",
    four_children: "2971",
    five_children: "3268",
    six_children: "3555",
  },
  {
    adjusted: "16050",
    one_child: "1687",
    two_children: "2345",
    three_children: "2669",
    four_children: "2976",
    five_children: "3274",
    six_children: "3562",
  },
  {
    adjusted: "16100",
    one_child: "1690",
    two_children: "2349",
    three_children: "2674",
    four_children: "2982",
    five_children: "3280",
    six_children: "3569",
  },
  {
    adjusted: "16150",
    one_child: "1692",
    two_children: "2353",
    three_children: "2678",
    four_children: "2986",
    five_children: "3285",
    six_children: "3574",
  },
  {
    adjusted: "16200",
    one_child: "1695",
    two_children: "2356",
    three_children: "2682",
    four_children: "2990",
    five_children: "3289",
    six_children: "3579",
  },
  {
    adjusted: "16250",
    one_child: "1698",
    two_children: "2360",
    three_children: "2686",
    four_children: "2994",
    five_children: "3294",
    six_children: "3584",
  },
  {
    adjusted: "16300",
    one_child: "1700",
    two_children: "2363",
    three_children: "2689",
    four_children: "2999",
    five_children: "3299",
    six_children: "3589",
  },
  {
    adjusted: "16350",
    one_child: "1703",
    two_children: "2367",
    three_children: "2693",
    four_children: "3003",
    five_children: "3303",
    six_children: "3594",
  },
  {
    adjusted: "16400",
    one_child: "1706",
    two_children: "2370",
    three_children: "2697",
    four_children: "3007",
    five_children: "3308",
    six_children: "3599",
  },
  {
    adjusted: "16450",
    one_child: "1708",
    two_children: "2374",
    three_children: "2701",
    four_children: "3011",
    five_children: "3313",
    six_children: "3604",
  },
  {
    adjusted: "16500",
    one_child: "1711",
    two_children: "2377",
    three_children: "2705",
    four_children: "3016",
    five_children: "3317",
    six_children: "3609",
  },
  {
    adjusted: "16550",
    one_child: "1714",
    two_children: "2381",
    three_children: "2708",
    four_children: "3020",
    five_children: "3322",
    six_children: "3614",
  },
  {
    adjusted: "16600",
    one_child: "1716",
    two_children: "2384",
    three_children: "2712",
    four_children: "3024",
    five_children: "3327",
    six_children: "3619",
  },
  {
    adjusted: "16650",
    one_child: "1719",
    two_children: "2388",
    three_children: "2716",
    four_children: "3028",
    five_children: "3331",
    six_children: "3624",
  },
  {
    adjusted: "16700",
    one_child: "1722",
    two_children: "2391",
    three_children: "2720",
    four_children: "3033",
    five_children: "3336",
    six_children: "3630",
  },
  {
    adjusted: "16750",
    one_child: "1724",
    two_children: "2395",
    three_children: "2724",
    four_children: "3037",
    five_children: "3341",
    six_children: "3635",
  },
  {
    adjusted: "16800",
    one_child: "1727",
    two_children: "2398",
    three_children: "2728",
    four_children: "3041",
    five_children: "3345",
    six_children: "3640",
  },
  {
    adjusted: "16850",
    one_child: "1730",
    two_children: "2402",
    three_children: "2731",
    four_children: "3045",
    five_children: "3350",
    six_children: "3645",
  },
  {
    adjusted: "16900",
    one_child: "1732",
    two_children: "2405",
    three_children: "2735",
    four_children: "3050",
    five_children: "3355",
    six_children: "3650",
  },
  {
    adjusted: "16950",
    one_child: "1735",
    two_children: "2409",
    three_children: "2739",
    four_children: "3054",
    five_children: "3359",
    six_children: "3655",
  },
  {
    adjusted: "17000",
    one_child: "1737",
    two_children: "2412",
    three_children: "2743",
    four_children: "3058",
    five_children: "3364",
    six_children: "3660",
  },
  {
    adjusted: "17050",
    one_child: "1740",
    two_children: "2416",
    three_children: "2747",
    four_children: "3062",
    five_children: "3369",
    six_children: "3665",
  },
  {
    adjusted: "17100",
    one_child: "1743",
    two_children: "2419",
    three_children: "2750",
    four_children: "3067",
    five_children: "3373",
    six_children: "3670",
  },
  {
    adjusted: "17150",
    one_child: "1745",
    two_children: "2423",
    three_children: "2754",
    four_children: "3071",
    five_children: "3378",
    six_children: "3675",
  },
  {
    adjusted: "17200",
    one_child: "1748",
    two_children: "2426",
    three_children: "2758",
    four_children: "3075",
    five_children: "3383",
    six_children: "3680",
  },
  {
    adjusted: "17250",
    one_child: "1751",
    two_children: "2430",
    three_children: "2762",
    four_children: "3079",
    five_children: "3387",
    six_children: "3685",
  },
  {
    adjusted: "17300",
    one_child: "1753",
    two_children: "2433",
    three_children: "2766",
    four_children: "3084",
    five_children: "3392",
    six_children: "3691",
  },
  {
    adjusted: "17350",
    one_child: "1756",
    two_children: "2437",
    three_children: "2769",
    four_children: "3088",
    five_children: "3397",
    six_children: "3696",
  },
  {
    adjusted: "17400",
    one_child: "1759",
    two_children: "2440",
    three_children: "2773",
    four_children: "3092",
    five_children: "3401",
    six_children: "3701",
  },
  {
    adjusted: "17450",
    one_child: "1761",
    two_children: "2444",
    three_children: "2777",
    four_children: "3096",
    five_children: "3406",
    six_children: "3706",
  },
  {
    adjusted: "17500",
    one_child: "1764",
    two_children: "2447",
    three_children: "2781",
    four_children: "3101",
    five_children: "3411",
    six_children: "3711",
  },
  {
    adjusted: "17550",
    one_child: "1767",
    two_children: "2451",
    three_children: "2785",
    four_children: "3105",
    five_children: "3415",
    six_children: "3716",
  },
  {
    adjusted: "17600",
    one_child: "1769",
    two_children: "2454",
    three_children: "2788",
    four_children: "3109",
    five_children: "3420",
    six_children: "3721",
  },
  {
    adjusted: "17650",
    one_child: "1772",
    two_children: "2458",
    three_children: "2792",
    four_children: "3113",
    five_children: "3425",
    six_children: "3726",
  },
  {
    adjusted: "17700",
    one_child: "1774",
    two_children: "2461",
    three_children: "2796",
    four_children: "3118",
    five_children: "3429",
    six_children: "3731",
  },
  {
    adjusted: "17750",
    one_child: "1777",
    two_children: "2465",
    three_children: "2800",
    four_children: "3122",
    five_children: "3434",
    six_children: "3736",
  },
  {
    adjusted: "17800",
    one_child: "1780",
    two_children: "2468",
    three_children: "2804",
    four_children: "3126",
    five_children: "3439",
    six_children: "3741",
  },
  {
    adjusted: "17850",
    one_child: "1782",
    two_children: "2472",
    three_children: "2808",
    four_children: "3130",
    five_children: "3443",
    six_children: "3746",
  },
  {
    adjusted: "17900",
    one_child: "1785",
    two_children: "2475",
    three_children: "2811",
    four_children: "3135",
    five_children: "3448",
    six_children: "3752",
  },
  {
    adjusted: "17950",
    one_child: "1788",
    two_children: "2478",
    three_children: "2815",
    four_children: "3139",
    five_children: "3453",
    six_children: "3757",
  },
  {
    adjusted: "18000",
    one_child: "1790",
    two_children: "2482",
    three_children: "2819",
    four_children: "3143",
    five_children: "3457",
    six_children: "3762",
  },
  {
    adjusted: "18050",
    one_child: "1793",
    two_children: "2485",
    three_children: "2823",
    four_children: "3147",
    five_children: "3462",
    six_children: "3767",
  },
  {
    adjusted: "18100",
    one_child: "1796",
    two_children: "2489",
    three_children: "2827",
    four_children: "3152",
    five_children: "3467",
    six_children: "3772",
  },
  {
    adjusted: "18150",
    one_child: "1798",
    two_children: "2492",
    three_children: "2830",
    four_children: "3156",
    five_children: "3471",
    six_children: "3777",
  },
  {
    adjusted: "18200",
    one_child: "1801",
    two_children: "2496",
    three_children: "2834",
    four_children: "3160",
    five_children: "3476",
    six_children: "3782",
  },
  {
    adjusted: "18250",
    one_child: "1804",
    two_children: "2499",
    three_children: "2838",
    four_children: "3164",
    five_children: "3481",
    six_children: "3787",
  },
  {
    adjusted: "18300",
    one_child: "1806",
    two_children: "2503",
    three_children: "2842",
    four_children: "3169",
    five_children: "3485",
    six_children: "3792",
  },
  {
    adjusted: "18350",
    one_child: "1809",
    two_children: "2506",
    three_children: "2846",
    four_children: "3173",
    five_children: "3490",
    six_children: "3797",
  },
  {
    adjusted: "18400",
    one_child: "1812",
    two_children: "2510",
    three_children: "2849",
    four_children: "3177",
    five_children: "3495",
    six_children: "3802",
  },
  {
    adjusted: "18450",
    one_child: "1814",
    two_children: "2513",
    three_children: "2853",
    four_children: "3181",
    five_children: "3499",
    six_children: "3807",
  },
  {
    adjusted: "18500",
    one_child: "1817",
    two_children: "2517",
    three_children: "2857",
    four_children: "3186",
    five_children: "3504",
    six_children: "3813",
  },
  {
    adjusted: "18550",
    one_child: "1819",
    two_children: "2520",
    three_children: "2861",
    four_children: "3190",
    five_children: "3509",
    six_children: "3818",
  },
  {
    adjusted: "18600",
    one_child: "1822",
    two_children: "2524",
    three_children: "2865",
    four_children: "3194",
    five_children: "3513",
    six_children: "3823",
  },
  {
    adjusted: "18650",
    one_child: "1825",
    two_children: "2527",
    three_children: "2868",
    four_children: "3198",
    five_children: "3518",
    six_children: "3828",
  },
  {
    adjusted: "18700",
    one_child: "1827",
    two_children: "2531",
    three_children: "2872",
    four_children: "3203",
    five_children: "3523",
    six_children: "3833",
  },
  {
    adjusted: "18750",
    one_child: "1830",
    two_children: "2534",
    three_children: "2876",
    four_children: "3207",
    five_children: "3528",
    six_children: "3838",
  },
  {
    adjusted: "18800",
    one_child: "1833",
    two_children: "2538",
    three_children: "2880",
    four_children: "3211",
    five_children: "3532",
    six_children: "3843",
  },
  {
    adjusted: "18850",
    one_child: "1835",
    two_children: "2541",
    three_children: "2884",
    four_children: "3215",
    five_children: "3537",
    six_children: "3848",
  },
  {
    adjusted: "18900",
    one_child: "1838",
    two_children: "2545",
    three_children: "2888",
    four_children: "3220",
    five_children: "3542",
    six_children: "3853",
  },
  {
    adjusted: "18950",
    one_child: "1841",
    two_children: "2548",
    three_children: "2891",
    four_children: "3224",
    five_children: "3546",
    six_children: "3858",
  },
  {
    adjusted: "19000",
    one_child: "1843",
    two_children: "2552",
    three_children: "2895",
    four_children: "3228",
    five_children: "3551",
    six_children: "3863",
  },
  {
    adjusted: "19050",
    one_child: "1846",
    two_children: "2555",
    three_children: "2899",
    four_children: "3232",
    five_children: "3556",
    six_children: "3868",
  },
  {
    adjusted: "19100",
    one_child: "1849",
    two_children: "2559",
    three_children: "2903",
    four_children: "3237",
    five_children: "3560",
    six_children: "3874",
  },
  {
    adjusted: "19150",
    one_child: "1851",
    two_children: "2562",
    three_children: "2907",
    four_children: "3241",
    five_children: "3565",
    six_children: "3879",
  },
  {
    adjusted: "19200",
    one_child: "1854",
    two_children: "2566",
    three_children: "2910",
    four_children: "3245",
    five_children: "3570",
    six_children: "3884",
  },
  {
    adjusted: "19250",
    one_child: "1856",
    two_children: "2569",
    three_children: "2914",
    four_children: "3249",
    five_children: "3574",
    six_children: "3889",
  },
  {
    adjusted: "19300",
    one_child: "1859",
    two_children: "2573",
    three_children: "2918",
    four_children: "3254",
    five_children: "3579",
    six_children: "3894",
  },
  {
    adjusted: "19350",
    one_child: "1862",
    two_children: "2576",
    three_children: "2922",
    four_children: "3258",
    five_children: "3584",
    six_children: "3899",
  },
  {
    adjusted: "19400",
    one_child: "1864",
    two_children: "2580",
    three_children: "2926",
    four_children: "3262",
    five_children: "3588",
    six_children: "3904",
  },
  {
    adjusted: "19450",
    one_child: "1867",
    two_children: "2583",
    three_children: "2929",
    four_children: "3266",
    five_children: "3593",
    six_children: "3909",
  },
  {
    adjusted: "19500",
    one_child: "1870",
    two_children: "2587",
    three_children: "2933",
    four_children: "3271",
    five_children: "3598",
    six_children: "3914",
  },
  {
    adjusted: "19550",
    one_child: "1872",
    two_children: "2590",
    three_children: "2937",
    four_children: "3275",
    five_children: "3602",
    six_children: "3919",
  },
  {
    adjusted: "19600",
    one_child: "1875",
    two_children: "2594",
    three_children: "2941",
    four_children: "3279",
    five_children: "3607",
    six_children: "3924",
  },
  {
    adjusted: "19650",
    one_child: "1878",
    two_children: "2597",
    three_children: "2945",
    four_children: "3283",
    five_children: "3612",
    six_children: "3929",
  },
  {
    adjusted: "19700",
    one_child: "1880",
    two_children: "2601",
    three_children: "2948",
    four_children: "3288",
    five_children: "3616",
    six_children: "3935",
  },
  {
    adjusted: "19750",
    one_child: "1883",
    two_children: "2604",
    three_children: "2952",
    four_children: "3292",
    five_children: "3621",
    six_children: "3940",
  },
  {
    adjusted: "19800",
    one_child: "1886",
    two_children: "2608",
    three_children: "2956",
    four_children: "3296",
    five_children: "3626",
    six_children: "3945",
  },
  {
    adjusted: "19850",
    one_child: "1888",
    two_children: "2611",
    three_children: "2960",
    four_children: "3300",
    five_children: "3630",
    six_children: "3950",
  },
  {
    adjusted: "19900",
    one_child: "1891",
    two_children: "2615",
    three_children: "2964",
    four_children: "3305",
    five_children: "3635",
    six_children: "3955",
  },
  {
    adjusted: "19950",
    one_child: "1893",
    two_children: "2618",
    three_children: "2967",
    four_children: "3309",
    five_children: "3640",
    six_children: "3960",
  },
  {
    adjusted: "20000",
    one_child: "1896",
    two_children: "2622",
    three_children: "2971",
    four_children: "3313",
    five_children: "3644",
    six_children: "3965",
  },
  {
    adjusted: "20050",
    one_child: "1899",
    two_children: "2625",
    three_children: "2975",
    four_children: "3317",
    five_children: "3649",
    six_children: "3970",
  },
  {
    adjusted: "20100",
    one_child: "1901",
    two_children: "2628",
    three_children: "2979",
    four_children: "3321",
    five_children: "3654",
    six_children: "3975",
  },
  {
    adjusted: "20150",
    one_child: "1904",
    two_children: "2632",
    three_children: "2983",
    four_children: "3326",
    five_children: "3658",
    six_children: "3980",
  },
  {
    adjusted: "20200",
    one_child: "1907",
    two_children: "2635",
    three_children: "2987",
    four_children: "3330",
    five_children: "3663",
    six_children: "3985",
  },
  {
    adjusted: "20250",
    one_child: "1909",
    two_children: "2639",
    three_children: "2990",
    four_children: "3334",
    five_children: "3668",
    six_children: "3990",
  },
  {
    adjusted: "20300",
    one_child: "1912",
    two_children: "2642",
    three_children: "2994",
    four_children: "3338",
    five_children: "3672",
    six_children: "3996",
  },
  {
    adjusted: "20350",
    one_child: "1915",
    two_children: "2646",
    three_children: "2998",
    four_children: "3343",
    five_children: "3677",
    six_children: "4001",
  },
  {
    adjusted: "20400",
    one_child: "1917",
    two_children: "2649",
    three_children: "3002",
    four_children: "3347",
    five_children: "3682",
    six_children: "4006",
  },
  {
    adjusted: "20450",
    one_child: "1920",
    two_children: "2653",
    three_children: "3006",
    four_children: "3351",
    five_children: "3686",
    six_children: "4011",
  },
  {
    adjusted: "20500",
    one_child: "1923",
    two_children: "2656",
    three_children: "3009",
    four_children: "3355",
    five_children: "3691",
    six_children: "4016",
  },
  {
    adjusted: "20550",
    one_child: "1925",
    two_children: "2660",
    three_children: "3013",
    four_children: "3360",
    five_children: "3696",
    six_children: "4021",
  },
  {
    adjusted: "20600",
    one_child: "1928",
    two_children: "2663",
    three_children: "3017",
    four_children: "3364",
    five_children: "3700",
    six_children: "4026",
  },
  {
    adjusted: "20650",
    one_child: "1931",
    two_children: "2667",
    three_children: "3021",
    four_children: "3368",
    five_children: "3705",
    six_children: "4031",
  },
  {
    adjusted: "20700",
    one_child: "1933",
    two_children: "2670",
    three_children: "3025",
    four_children: "3372",
    five_children: "3710",
    six_children: "4036",
  },
  {
    adjusted: "20750",
    one_child: "1936",
    two_children: "2674",
    three_children: "3028",
    four_children: "3377",
    five_children: "3714",
    six_children: "4041",
  },
  {
    adjusted: "20800",
    one_child: "1938",
    two_children: "2677",
    three_children: "3032",
    four_children: "3381",
    five_children: "3719",
    six_children: "4046",
  },
  {
    adjusted: "20850",
    one_child: "1941",
    two_children: "2681",
    three_children: "3036",
    four_children: "3385",
    five_children: "3724",
    six_children: "4051",
  },
  {
    adjusted: "20900",
    one_child: "1944",
    two_children: "2684",
    three_children: "3040",
    four_children: "3389",
    five_children: "3728",
    six_children: "4056",
  },
  {
    adjusted: "20950",
    one_child: "1946",
    two_children: "2688",
    three_children: "3044",
    four_children: "3394",
    five_children: "3733",
    six_children: "4062",
  },
  {
    adjusted: "21000",
    one_child: "1949",
    two_children: "2691",
    three_children: "3047",
    four_children: "3398",
    five_children: "3738",
    six_children: "4067",
  },
  {
    adjusted: "21050",
    one_child: "1952",
    two_children: "2695",
    three_children: "3051",
    four_children: "3402",
    five_children: "3742",
    six_children: "4072",
  },
  {
    adjusted: "21100",
    one_child: "1954",
    two_children: "2698",
    three_children: "3055",
    four_children: "3406",
    five_children: "3747",
    six_children: "4077",
  },
  {
    adjusted: "21150",
    one_child: "1957",
    two_children: "2702",
    three_children: "3059",
    four_children: "3411",
    five_children: "3752",
    six_children: "4082",
  },
  {
    adjusted: "21200",
    one_child: "1960",
    two_children: "2705",
    three_children: "3063",
    four_children: "3415",
    five_children: "3756",
    six_children: "4087",
  },
  {
    adjusted: "21250",
    one_child: "1962",
    two_children: "2709",
    three_children: "3067",
    four_children: "3419",
    five_children: "3761",
    six_children: "4092",
  },
  {
    adjusted: "21300",
    one_child: "1965",
    two_children: "2712",
    three_children: "3070",
    four_children: "3423",
    five_children: "3766",
    six_children: "4097",
  },
  {
    adjusted: "21350",
    one_child: "1968",
    two_children: "2716",
    three_children: "3074",
    four_children: "3428",
    five_children: "3770",
    six_children: "4102",
  },
  {
    adjusted: "21400",
    one_child: "1970",
    two_children: "2719",
    three_children: "3078",
    four_children: "3432",
    five_children: "3775",
    six_children: "4107",
  },
  {
    adjusted: "21450",
    one_child: "1973",
    two_children: "2723",
    three_children: "3082",
    four_children: "3436",
    five_children: "3780",
    six_children: "4112",
  },
  {
    adjusted: "21500",
    one_child: "1975",
    two_children: "2726",
    three_children: "3086",
    four_children: "3440",
    five_children: "3784",
    six_children: "4117",
  },
  {
    adjusted: "21550",
    one_child: "1978",
    two_children: "2730",
    three_children: "3089",
    four_children: "3445",
    five_children: "3789",
    six_children: "4123",
  },
  {
    adjusted: "21600",
    one_child: "1981",
    two_children: "2733",
    three_children: "3093",
    four_children: "3449",
    five_children: "3794",
    six_children: "4128",
  },
  {
    adjusted: "21650",
    one_child: "1983",
    two_children: "2737",
    three_children: "3097",
    four_children: "3453",
    five_children: "3798",
    six_children: "4133",
  },
  {
    adjusted: "21700",
    one_child: "1986",
    two_children: "2740",
    three_children: "3101",
    four_children: "3457",
    five_children: "3803",
    six_children: "4138",
  },
  {
    adjusted: "21750",
    one_child: "1989",
    two_children: "2744",
    three_children: "3105",
    four_children: "3462",
    five_children: "3808",
    six_children: "4143",
  },
  {
    adjusted: "21800",
    one_child: "1991",
    two_children: "2747",
    three_children: "3108",
    four_children: "3466",
    five_children: "3812",
    six_children: "4148",
  },
  {
    adjusted: "21850",
    one_child: "1994",
    two_children: "2751",
    three_children: "3112",
    four_children: "3470",
    five_children: "3817",
    six_children: "4153",
  },
  {
    adjusted: "21900",
    one_child: "1997",
    two_children: "2754",
    three_children: "3116",
    four_children: "3474",
    five_children: "3822",
    six_children: "4158",
  },
  {
    adjusted: "21950",
    one_child: "1999",
    two_children: "2758",
    three_children: "3120",
    four_children: "3479",
    five_children: "3827",
    six_children: "4163",
  },
  {
    adjusted: "22000",
    one_child: "2002",
    two_children: "2761",
    three_children: "3124",
    four_children: "3483",
    five_children: "3831",
    six_children: "4168",
  },
  {
    adjusted: "22050",
    one_child: "2005",
    two_children: "2765",
    three_children: "3127",
    four_children: "3487",
    five_children: "3836",
    six_children: "4173",
  },
  {
    adjusted: "22100",
    one_child: "2007",
    two_children: "2768",
    three_children: "3131",
    four_children: "3491",
    five_children: "3841",
    six_children: "4178",
  },
  {
    adjusted: "22150",
    one_child: "2010",
    two_children: "2772",
    three_children: "3135",
    four_children: "3496",
    five_children: "3845",
    six_children: "4184",
  },
  {
    adjusted: "22200",
    one_child: "2012",
    two_children: "2775",
    three_children: "3139",
    four_children: "3500",
    five_children: "3850",
    six_children: "4189",
  },
  {
    adjusted: "22250",
    one_child: "2015",
    two_children: "2779",
    three_children: "3143",
    four_children: "3504",
    five_children: "3855",
    six_children: "4194",
  },
  {
    adjusted: "22300",
    one_child: "2018",
    two_children: "2782",
    three_children: "3147",
    four_children: "3508",
    five_children: "3859",
    six_children: "4199",
  },
  {
    adjusted: "22350",
    one_child: "2020",
    two_children: "2785",
    three_children: "3150",
    four_children: "3513",
    five_children: "3864",
    six_children: "4204",
  },
  {
    adjusted: "22400",
    one_child: "2022",
    two_children: "2788",
    three_children: "3153",
    four_children: "3515",
    five_children: "3867",
    six_children: "4207",
  },
  {
    adjusted: "22450",
    one_child: "2024",
    two_children: "2790",
    three_children: "3155",
    four_children: "3517",
    five_children: "3869",
    six_children: "4210",
  },
  {
    adjusted: "22500",
    one_child: "2025",
    two_children: "2792",
    three_children: "3157",
    four_children: "3520",
    five_children: "3872",
    six_children: "4212",
  },
  {
    adjusted: "22550",
    one_child: "2027",
    two_children: "2793",
    three_children: "3158",
    four_children: "3522",
    five_children: "3874",
    six_children: "4215",
  },
  {
    adjusted: "22600",
    one_child: "2028",
    two_children: "2795",
    three_children: "3160",
    four_children: "3524",
    five_children: "3876",
    six_children: "4217",
  },
  {
    adjusted: "22650",
    one_child: "2029",
    two_children: "2797",
    three_children: "3162",
    four_children: "3526",
    five_children: "3878",
    six_children: "4220",
  },
  {
    adjusted: "22700",
    one_child: "2031",
    two_children: "2799",
    three_children: "3164",
    four_children: "3528",
    five_children: "3881",
    six_children: "4222",
  },
  {
    adjusted: "22750",
    one_child: "2032",
    two_children: "2801",
    three_children: "3166",
    four_children: "3530",
    five_children: "3883",
    six_children: "4225",
  },
  {
    adjusted: "22800",
    one_child: "2034",
    two_children: "2803",
    three_children: "3168",
    four_children: "3532",
    five_children: "3885",
    six_children: "4227",
  },
  {
    adjusted: "22850",
    one_child: "2035",
    two_children: "2804",
    three_children: "3169",
    four_children: "3534",
    five_children: "3888",
    six_children: "4230",
  },
  {
    adjusted: "22900",
    one_child: "2036",
    two_children: "2806",
    three_children: "3171",
    four_children: "3536",
    five_children: "3890",
    six_children: "4232",
  },
  {
    adjusted: "22950",
    one_child: "2038",
    two_children: "2808",
    three_children: "3173",
    four_children: "3538",
    five_children: "3892",
    six_children: "4235",
  },
  {
    adjusted: "23000",
    one_child: "2039",
    two_children: "2810",
    three_children: "3175",
    four_children: "3540",
    five_children: "3894",
    six_children: "4237",
  },
  {
    adjusted: "23050",
    one_child: "2041",
    two_children: "2812",
    three_children: "3177",
    four_children: "3542",
    five_children: "3897",
    six_children: "4240",
  },
  {
    adjusted: "23100",
    one_child: "2042",
    two_children: "2814",
    three_children: "3179",
    four_children: "3544",
    five_children: "3899",
    six_children: "4242",
  },
  {
    adjusted: "23150",
    one_child: "2044",
    two_children: "2816",
    three_children: "3181",
    four_children: "3546",
    five_children: "3901",
    six_children: "4245",
  },
  {
    adjusted: "23200",
    one_child: "2045",
    two_children: "2817",
    three_children: "3182",
    four_children: "3548",
    five_children: "3904",
    six_children: "4247",
  },
  {
    adjusted: "23250",
    one_child: "2046",
    two_children: "2819",
    three_children: "3184",
    four_children: "3550",
    five_children: "3906",
    six_children: "4250",
  },
  {
    adjusted: "23300",
    one_child: "2048",
    two_children: "2821",
    three_children: "3186",
    four_children: "3552",
    five_children: "3908",
    six_children: "4252",
  },
  {
    adjusted: "23350",
    one_child: "2049",
    two_children: "2823",
    three_children: "3188",
    four_children: "3555",
    five_children: "3910",
    six_children: "4254",
  },
  {
    adjusted: "23400",
    one_child: "2051",
    two_children: "2825",
    three_children: "3190",
    four_children: "3557",
    five_children: "3913",
    six_children: "4257",
  },
  {
    adjusted: "23450",
    one_child: "2052",
    two_children: "2827",
    three_children: "3192",
    four_children: "3559",
    five_children: "3915",
    six_children: "4259",
  },
  {
    adjusted: "23500",
    one_child: "2053",
    two_children: "2828",
    three_children: "3193",
    four_children: "3561",
    five_children: "3917",
    six_children: "4262",
  },
  {
    adjusted: "23550",
    one_child: "2055",
    two_children: "2830",
    three_children: "3195",
    four_children: "3563",
    five_children: "3919",
    six_children: "4264",
  },
  {
    adjusted: "23600",
    one_child: "2056",
    two_children: "2832",
    three_children: "3197",
    four_children: "3565",
    five_children: "3922",
    six_children: "4267",
  },
  {
    adjusted: "23650",
    one_child: "2058",
    two_children: "2834",
    three_children: "3199",
    four_children: "3567",
    five_children: "3924",
    six_children: "4269",
  },
  {
    adjusted: "23700",
    one_child: "2059",
    two_children: "2836",
    three_children: "3201",
    four_children: "3569",
    five_children: "3926",
    six_children: "4272",
  },
  {
    adjusted: "23750",
    one_child: "2061",
    two_children: "2838",
    three_children: "3203",
    four_children: "3571",
    five_children: "3929",
    six_children: "4274",
  },
  {
    adjusted: "23800",
    one_child: "2062",
    two_children: "2840",
    three_children: "3204",
    four_children: "3573",
    five_children: "3931",
    six_children: "4277",
  },
  {
    adjusted: "23850",
    one_child: "2063",
    two_children: "2841",
    three_children: "3206",
    four_children: "3575",
    five_children: "3933",
    six_children: "4279",
  },
  {
    adjusted: "23900",
    one_child: "2065",
    two_children: "2843",
    three_children: "3208",
    four_children: "3577",
    five_children: "3935",
    six_children: "4282",
  },
  {
    adjusted: "23950",
    one_child: "2066",
    two_children: "2845",
    three_children: "3210",
    four_children: "3579",
    five_children: "3938",
    six_children: "4284",
  },
  {
    adjusted: "24000",
    one_child: "2068",
    two_children: "2847",
    three_children: "3212",
    four_children: "3581",
    five_children: "3940",
    six_children: "4287",
  },
  {
    adjusted: "24050",
    one_child: "2069",
    two_children: "2849",
    three_children: "3214",
    four_children: "3583",
    five_children: "3942",
    six_children: "4289",
  },
  {
    adjusted: "24100",
    one_child: "2070",
    two_children: "2851",
    three_children: "3216",
    four_children: "3585",
    five_children: "3945",
    six_children: "4292",
  },
  {
    adjusted: "24150",
    one_child: "2072",
    two_children: "2852",
    three_children: "3217",
    four_children: "3587",
    five_children: "3947",
    six_children: "4294",
  },
  {
    adjusted: "24200",
    one_child: "2073",
    two_children: "2854",
    three_children: "3219",
    four_children: "3589",
    five_children: "3949",
    six_children: "4297",
  },
  {
    adjusted: "24250",
    one_child: "2075",
    two_children: "2856",
    three_children: "3221",
    four_children: "3592",
    five_children: "3951",
    six_children: "4299",
  },
  {
    adjusted: "24300",
    one_child: "2076",
    two_children: "2858",
    three_children: "3223",
    four_children: "3594",
    five_children: "3954",
    six_children: "4302",
  },
  {
    adjusted: "24350",
    one_child: "2077",
    two_children: "2860",
    three_children: "3225",
    four_children: "3596",
    five_children: "3956",
    six_children: "4304",
  },
  {
    adjusted: "24400",
    one_child: "2079",
    two_children: "2862",
    three_children: "3227",
    four_children: "3598",
    five_children: "3958",
    six_children: "4307",
  },
  {
    adjusted: "24450",
    one_child: "2080",
    two_children: "2864",
    three_children: "3228",
    four_children: "3600",
    five_children: "3961",
    six_children: "4309",
  },
  {
    adjusted: "24500",
    one_child: "2082",
    two_children: "2865",
    three_children: "3230",
    four_children: "3602",
    five_children: "3963",
    six_children: "4312",
  },
  {
    adjusted: "24550",
    one_child: "2083",
    two_children: "2867",
    three_children: "3232",
    four_children: "3604",
    five_children: "3965",
    six_children: "4314",
  },
  {
    adjusted: "24600",
    one_child: "2085",
    two_children: "2869",
    three_children: "3234",
    four_children: "3606",
    five_children: "3967",
    six_children: "4317",
  },
  {
    adjusted: "24650",
    one_child: "2086",
    two_children: "2871",
    three_children: "3236",
    four_children: "3608",
    five_children: "3970",
    six_children: "4319",
  },
  {
    adjusted: "24700",
    one_child: "2087",
    two_children: "2873",
    three_children: "3238",
    four_children: "3610",
    five_children: "3972",
    six_children: "4322",
  },
  {
    adjusted: "24750",
    one_child: "2089",
    two_children: "2875",
    three_children: "3240",
    four_children: "3612",
    five_children: "3974",
    six_children: "4324",
  },
  {
    adjusted: "24800",
    one_child: "2090",
    two_children: "2876",
    three_children: "3241",
    four_children: "3614",
    five_children: "3977",
    six_children: "4326",
  },
  {
    adjusted: "24850",
    one_child: "2092",
    two_children: "2878",
    three_children: "3243",
    four_children: "3616",
    five_children: "3979",
    six_children: "4329",
  },
  {
    adjusted: "24900",
    one_child: "2093",
    two_children: "2880",
    three_children: "3245",
    four_children: "3618",
    five_children: "3981",
    six_children: "4331",
  },
  {
    adjusted: "24950",
    one_child: "2094",
    two_children: "2882",
    three_children: "3247",
    four_children: "3620",
    five_children: "3983",
    six_children: "4334",
  },
  {
    adjusted: "25000",
    one_child: "2096",
    two_children: "2884",
    three_children: "3249",
    four_children: "3622",
    five_children: "3986",
    six_children: "4336",
  },
  {
    adjusted: "25050",
    one_child: "2097",
    two_children: "2886",
    three_children: "3251",
    four_children: "3624",
    five_children: "3988",
    six_children: "4339",
  },
  {
    adjusted: "25100",
    one_child: "2099",
    two_children: "2887",
    three_children: "3252",
    four_children: "3626",
    five_children: "3990",
    six_children: "4341",
  },
  {
    adjusted: "25150",
    one_child: "2100",
    two_children: "2889",
    three_children: "3254",
    four_children: "3629",
    five_children: "3993",
    six_children: "4344",
  },
  {
    adjusted: "25200",
    one_child: "2102",
    two_children: "2891",
    three_children: "3256",
    four_children: "3631",
    five_children: "3995",
    six_children: "4346",
  },
  {
    adjusted: "25250",
    one_child: "2103",
    two_children: "2893",
    three_children: "3258",
    four_children: "3633",
    five_children: "3997",
    six_children: "4349",
  },
  {
    adjusted: "25300",
    one_child: "2104",
    two_children: "2895",
    three_children: "3260",
    four_children: "3635",
    five_children: "3999",
    six_children: "4351",
  },
  {
    adjusted: "25350",
    one_child: "2106",
    two_children: "2897",
    three_children: "3262",
    four_children: "3637",
    five_children: "4002",
    six_children: "4354",
  },
  {
    adjusted: "25400",
    one_child: "2107",
    two_children: "2899",
    three_children: "3264",
    four_children: "3639",
    five_children: "4004",
    six_children: "4356",
  },
  {
    adjusted: "25450",
    one_child: "2109",
    two_children: "2900",
    three_children: "3265",
    four_children: "3641",
    five_children: "4006",
    six_children: "4359",
  },
  {
    adjusted: "25500",
    one_child: "2110",
    two_children: "2902",
    three_children: "3267",
    four_children: "3643",
    five_children: "4009",
    six_children: "4361",
  },
  {
    adjusted: "25550",
    one_child: "2111",
    two_children: "2904",
    three_children: "3269",
    four_children: "3645",
    five_children: "4011",
    six_children: "4364",
  },
  {
    adjusted: "25600",
    one_child: "2113",
    two_children: "2906",
    three_children: "3271",
    four_children: "3647",
    five_children: "4013",
    six_children: "4366",
  },
  {
    adjusted: "25650",
    one_child: "2114",
    two_children: "2908",
    three_children: "3273",
    four_children: "3649",
    five_children: "4015",
    six_children: "4369",
  },
  {
    adjusted: "25700",
    one_child: "2116",
    two_children: "2910",
    three_children: "3275",
    four_children: "3651",
    five_children: "4018",
    six_children: "4371",
  },
  {
    adjusted: "25750",
    one_child: "2117",
    two_children: "2911",
    three_children: "3276",
    four_children: "3653",
    five_children: "4020",
    six_children: "4374",
  },
  {
    adjusted: "25800",
    one_child: "2119",
    two_children: "2913",
    three_children: "3278",
    four_children: "3655",
    five_children: "4022",
    six_children: "4376",
  },
  {
    adjusted: "25850",
    one_child: "2120",
    two_children: "2915",
    three_children: "3280",
    four_children: "3657",
    five_children: "4024",
    six_children: "4379",
  },
  {
    adjusted: "25900",
    one_child: "2121",
    two_children: "2917",
    three_children: "3282",
    four_children: "3659",
    five_children: "4027",
    six_children: "4381",
  },
  {
    adjusted: "25950",
    one_child: "2123",
    two_children: "2919",
    three_children: "3284",
    four_children: "3661",
    five_children: "4029",
    six_children: "4384",
  },
  {
    adjusted: "26000",
    one_child: "2124",
    two_children: "2921",
    three_children: "3286",
    four_children: "3663",
    five_children: "4031",
    six_children: "4386",
  },
  {
    adjusted: "26050",
    one_child: "2126",
    two_children: "2923",
    three_children: "3287",
    four_children: "3666",
    five_children: "4034",
    six_children: "4389",
  },
  {
    adjusted: "26100",
    one_child: "2127",
    two_children: "2924",
    three_children: "3289",
    four_children: "3668",
    five_children: "4036",
    six_children: "4391",
  },
  {
    adjusted: "26150",
    one_child: "2128",
    two_children: "2926",
    three_children: "3291",
    four_children: "3670",
    five_children: "4038",
    six_children: "4394",
  },
  {
    adjusted: "26200",
    one_child: "2130",
    two_children: "2928",
    three_children: "3293",
    four_children: "3672",
    five_children: "4040",
    six_children: "4396",
  },
  {
    adjusted: "26250",
    one_child: "2131",
    two_children: "2930",
    three_children: "3295",
    four_children: "3674",
    five_children: "4043",
    six_children: "4399",
  },
  {
    adjusted: "26300",
    one_child: "2133",
    two_children: "2932",
    three_children: "3297",
    four_children: "3676",
    five_children: "4045",
    six_children: "4401",
  },
  {
    adjusted: "26350",
    one_child: "2134",
    two_children: "2934",
    three_children: "3299",
    four_children: "3678",
    five_children: "4047",
    six_children: "4403",
  },
  {
    adjusted: "26400",
    one_child: "2136",
    two_children: "2935",
    three_children: "3300",
    four_children: "3680",
    five_children: "4050",
    six_children: "4406",
  },
  {
    adjusted: "26450",
    one_child: "2137",
    two_children: "2937",
    three_children: "3302",
    four_children: "3682",
    five_children: "4052",
    six_children: "4408",
  },
  {
    adjusted: "26500",
    one_child: "2138",
    two_children: "2939",
    three_children: "3304",
    four_children: "3684",
    five_children: "4054",
    six_children: "4411",
  },
  {
    adjusted: "26550",
    one_child: "2140",
    two_children: "2941",
    three_children: "3306",
    four_children: "3686",
    five_children: "4056",
    six_children: "4413",
  },
  {
    adjusted: "26600",
    one_child: "2141",
    two_children: "2943",
    three_children: "3308",
    four_children: "3688",
    five_children: "4059",
    six_children: "4416",
  },
  {
    adjusted: "26650",
    one_child: "2143",
    two_children: "2945",
    three_children: "3310",
    four_children: "3690",
    five_children: "4061",
    six_children: "4418",
  },
  {
    adjusted: "26700",
    one_child: "2144",
    two_children: "2947",
    three_children: "3311",
    four_children: "3692",
    five_children: "4063",
    six_children: "4421",
  },
  {
    adjusted: "26750",
    one_child: "2145",
    two_children: "2948",
    three_children: "3313",
    four_children: "3694",
    five_children: "4066",
    six_children: "4423",
  },
  {
    adjusted: "26800",
    one_child: "2147",
    two_children: "2950",
    three_children: "3315",
    four_children: "3696",
    five_children: "4068",
    six_children: "4426",
  },
  {
    adjusted: "26850",
    one_child: "2148",
    two_children: "2952",
    three_children: "3317",
    four_children: "3698",
    five_children: "4070",
    six_children: "4428",
  },
  {
    adjusted: "26900",
    one_child: "2150",
    two_children: "2954",
    three_children: "3319",
    four_children: "3701",
    five_children: "4072",
    six_children: "4431",
  },
  {
    adjusted: "26950",
    one_child: "2151",
    two_children: "2956",
    three_children: "3321",
    four_children: "3703",
    five_children: "4075",
    six_children: "4433",
  },
  {
    adjusted: "27000",
    one_child: "2153",
    two_children: "2958",
    three_children: "3323",
    four_children: "3705",
    five_children: "4077",
    six_children: "4436",
  },
  {
    adjusted: "27050",
    one_child: "2154",
    two_children: "2959",
    three_children: "3324",
    four_children: "3707",
    five_children: "4079",
    six_children: "4438",
  },
  {
    adjusted: "27100",
    one_child: "2155",
    two_children: "2961",
    three_children: "3326",
    four_children: "3709",
    five_children: "4082",
    six_children: "4441",
  },
  {
    adjusted: "27150",
    one_child: "2157",
    two_children: "2963",
    three_children: "3328",
    four_children: "3711",
    five_children: "4084",
    six_children: "4443",
  },
  {
    adjusted: "27200",
    one_child: "2158",
    two_children: "2965",
    three_children: "3330",
    four_children: "3713",
    five_children: "4086",
    six_children: "4446",
  },
  {
    adjusted: "27250",
    one_child: "2160",
    two_children: "2967",
    three_children: "3332",
    four_children: "3715",
    five_children: "4088",
    six_children: "4448",
  },
  {
    adjusted: "27300",
    one_child: "2161",
    two_children: "2969",
    three_children: "3334",
    four_children: "3717",
    five_children: "4091",
    six_children: "4451",
  },
  {
    adjusted: "27350",
    one_child: "2162",
    two_children: "2970",
    three_children: "3335",
    four_children: "3719",
    five_children: "4093",
    six_children: "4453",
  },
  {
    adjusted: "27400",
    one_child: "2164",
    two_children: "2972",
    three_children: "3337",
    four_children: "3721",
    five_children: "4095",
    six_children: "4456",
  },
  {
    adjusted: "27450",
    one_child: "2165",
    two_children: "2974",
    three_children: "3339",
    four_children: "3723",
    five_children: "4098",
    six_children: "4458",
  },
  {
    adjusted: "27500",
    one_child: "2167",
    two_children: "2976",
    three_children: "3341",
    four_children: "3725",
    five_children: "4100",
    six_children: "4461",
  },
  {
    adjusted: "27550",
    one_child: "2168",
    two_children: "2978",
    three_children: "3343",
    four_children: "3727",
    five_children: "4102",
    six_children: "4463",
  },
  {
    adjusted: "27600",
    one_child: "2170",
    two_children: "2980",
    three_children: "3345",
    four_children: "3729",
    five_children: "4104",
    six_children: "4466",
  },
  {
    adjusted: "27650",
    one_child: "2171",
    two_children: "2982",
    three_children: "3347",
    four_children: "3731",
    five_children: "4107",
    six_children: "4468",
  },
  {
    adjusted: "27700",
    one_child: "2172",
    two_children: "2983",
    three_children: "3348",
    four_children: "3733",
    five_children: "4109",
    six_children: "4471",
  },
  {
    adjusted: "27750",
    one_child: "2174",
    two_children: "2985",
    three_children: "3350",
    four_children: "3735",
    five_children: "4111",
    six_children: "4473",
  },
  {
    adjusted: "27800",
    one_child: "2175",
    two_children: "2987",
    three_children: "3352",
    four_children: "3738",
    five_children: "4114",
    six_children: "4475",
  },
  {
    adjusted: "27850",
    one_child: "2177",
    two_children: "2989",
    three_children: "3354",
    four_children: "3740",
    five_children: "4116",
    six_children: "4478",
  },
  {
    adjusted: "27900",
    one_child: "2178",
    two_children: "2991",
    three_children: "3356",
    four_children: "3742",
    five_children: "4118",
    six_children: "4480",
  },
  {
    adjusted: "27950",
    one_child: "2179",
    two_children: "2993",
    three_children: "3357",
    four_children: "3744",
    five_children: "4120",
    six_children: "4483",
  },
  {
    adjusted: "28000",
    one_child: "2181",
    two_children: "2994",
    three_children: "3359",
    four_children: "3746",
    five_children: "4122",
    six_children: "4485",
  },
  {
    adjusted: "28050",
    one_child: "2182",
    two_children: "2996",
    three_children: "3361",
    four_children: "3748",
    five_children: "4125",
    six_children: "4488",
  },
  {
    adjusted: "28100",
    one_child: "2184",
    two_children: "2998",
    three_children: "3363",
    four_children: "3750",
    five_children: "4127",
    six_children: "4490",
  },
  {
    adjusted: "28150",
    one_child: "2185",
    two_children: "3000",
    three_children: "3365",
    four_children: "3752",
    five_children: "4129",
    six_children: "4492",
  },
  {
    adjusted: "28200",
    one_child: "2186",
    two_children: "3001",
    three_children: "3366",
    four_children: "3754",
    five_children: "4131",
    six_children: "4495",
  },
  {
    adjusted: "28250",
    one_child: "2188",
    two_children: "3003",
    three_children: "3368",
    four_children: "3756",
    five_children: "4133",
    six_children: "4497",
  },
  {
    adjusted: "28300",
    one_child: "2189",
    two_children: "3005",
    three_children: "3370",
    four_children: "3758",
    five_children: "4136",
    six_children: "4500",
  },
  {
    adjusted: "28350",
    one_child: "2190",
    two_children: "3007",
    three_children: "3372",
    four_children: "3759",
    five_children: "4138",
    six_children: "4502",
  },
  {
    adjusted: "28400",
    one_child: "2192",
    two_children: "3009",
    three_children: "3374",
    four_children: "3761",
    five_children: "4140",
    six_children: "4504",
  },
  {
    adjusted: "28450",
    one_child: "2193",
    two_children: "3010",
    three_children: "3375",
    four_children: "3763",
    five_children: "4142",
    six_children: "4507",
  },
  {
    adjusted: "28500",
    one_child: "2194",
    two_children: "3012",
    three_children: "3377",
    four_children: "3765",
    five_children: "4145",
    six_children: "4509",
  },
  {
    adjusted: "28550",
    one_child: "2196",
    two_children: "3014",
    three_children: "3379",
    four_children: "3767",
    five_children: "4147",
    six_children: "4512",
  },
  {
    adjusted: "28600",
    one_child: "2197",
    two_children: "3016",
    three_children: "3381",
    four_children: "3769",
    five_children: "4149",
    six_children: "4514",
  },
  {
    adjusted: "28650",
    one_child: "2199",
    two_children: "3017",
    three_children: "3382",
    four_children: "3771",
    five_children: "4151",
    six_children: "4516",
  },
  {
    adjusted: "28700",
    one_child: "2200",
    two_children: "3019",
    three_children: "3384",
    four_children: "3773",
    five_children: "4153",
    six_children: "4519",
  },
  {
    adjusted: "28750",
    one_child: "2201",
    two_children: "3021",
    three_children: "3386",
    four_children: "3775",
    five_children: "4156",
    six_children: "4521",
  },
  {
    adjusted: "28800",
    one_child: "2203",
    two_children: "3023",
    three_children: "3388",
    four_children: "3777",
    five_children: "4158",
    six_children: "4524",
  },
  {
    adjusted: "28850",
    one_child: "2204",
    two_children: "3025",
    three_children: "3390",
    four_children: "3779",
    five_children: "4160",
    six_children: "4526",
  },
  {
    adjusted: "28900",
    one_child: "2205",
    two_children: "3026",
    three_children: "3391",
    four_children: "3781",
    five_children: "4162",
    six_children: "4528",
  },
  {
    adjusted: "28950",
    one_child: "2207",
    two_children: "3028",
    three_children: "3393",
    four_children: "3783",
    five_children: "4164",
    six_children: "4531",
  },
  {
    adjusted: "29000",
    one_child: "2208",
    two_children: "3030",
    three_children: "3395",
    four_children: "3785",
    five_children: "4167",
    six_children: "4533",
  },
  {
    adjusted: "29050",
    one_child: "2210",
    two_children: "3032",
    three_children: "3397",
    four_children: "3787",
    five_children: "4169",
    six_children: "4536",
  },
  {
    adjusted: "29100",
    one_child: "2211",
    two_children: "3034",
    three_children: "3398",
    four_children: "3789",
    five_children: "4171",
    six_children: "4538",
  },
  {
    adjusted: "29150",
    one_child: "2212",
    two_children: "3035",
    three_children: "3400",
    four_children: "3791",
    five_children: "4173",
    six_children: "4540",
  },
  {
    adjusted: "29200",
    one_child: "2214",
    two_children: "3037",
    three_children: "3402",
    four_children: "3793",
    five_children: "4175",
    six_children: "4543",
  },
  {
    adjusted: "29250",
    one_child: "2215",
    two_children: "3039",
    three_children: "3404",
    four_children: "3795",
    five_children: "4178",
    six_children: "4545",
  },
  {
    adjusted: "29300",
    one_child: "2216",
    two_children: "3041",
    three_children: "3406",
    four_children: "3797",
    five_children: "4180",
    six_children: "4548",
  },
  {
    adjusted: "29350",
    one_child: "2218",
    two_children: "3042",
    three_children: "3407",
    four_children: "3799",
    five_children: "4182",
    six_children: "4550",
  },
  {
    adjusted: "29400",
    one_child: "2219",
    two_children: "3044",
    three_children: "3409",
    four_children: "3801",
    five_children: "4184",
    six_children: "4552",
  },
  {
    adjusted: "29450",
    one_child: "2220",
    two_children: "3046",
    three_children: "3411",
    four_children: "3803",
    five_children: "4186",
    six_children: "4555",
  },
  {
    adjusted: "29500",
    one_child: "2222",
    two_children: "3048",
    three_children: "3413",
    four_children: "3805",
    five_children: "4189",
    six_children: "4557",
  },
  {
    adjusted: "29550",
    one_child: "2223",
    two_children: "3050",
    three_children: "3415",
    four_children: "3807",
    five_children: "4191",
    six_children: "4560",
  },
  {
    adjusted: "29600",
    one_child: "2225",
    two_children: "3051",
    three_children: "3416",
    four_children: "3809",
    five_children: "4193",
    six_children: "4562",
  },
  {
    adjusted: "29650",
    one_child: "2226",
    two_children: "3053",
    three_children: "3418",
    four_children: "3811",
    five_children: "4195",
    six_children: "4564",
  },
  {
    adjusted: "29700",
    one_child: "2227",
    two_children: "3055",
    three_children: "3420",
    four_children: "3813",
    five_children: "4197",
    six_children: "4567",
  },
  {
    adjusted: "29750",
    one_child: "2229",
    two_children: "3057",
    three_children: "3422",
    four_children: "3815",
    five_children: "4200",
    six_children: "4569",
  },
  {
    adjusted: "29800",
    one_child: "2230",
    two_children: "3058",
    three_children: "3423",
    four_children: "3817",
    five_children: "4202",
    six_children: "4572",
  },
  {
    adjusted: "29850",
    one_child: "2231",
    two_children: "3060",
    three_children: "3425",
    four_children: "3819",
    five_children: "4204",
    six_children: "4574",
  },
  {
    adjusted: "29900",
    one_child: "2233",
    two_children: "3062",
    three_children: "3427",
    four_children: "3821",
    five_children: "4206",
    six_children: "4576",
  },
  {
    adjusted: "29950",
    one_child: "2234",
    two_children: "3064",
    three_children: "3429",
    four_children: "3823",
    five_children: "4208",
    six_children: "4579",
  },
  {
    adjusted: "30000",
    one_child: "2236",
    two_children: "3066",
    three_children: "3431",
    four_children: "3825",
    five_children: "4211",
    six_children: "4581",
  },
];
